var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.631 13.915c-4.64-.631-21.802-1.51-29.437-2.748-6.148-1.014-12.162-2.838-17.905-4.752-1.486-.496-4.099-1.51-5.788-2.433C3.442 3.172.875 1.955.177.83 11.303 6.1 15.785 7.541 28.825 10.2c5.293 1.08 24.527 2.634 28.806 3.716z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .67l.206.098c11.12 5.268 15.597 6.708 28.633 9.364 2.51.513 8.168 1.133 13.879 1.76l.898.098c6.001.658 11.886 1.317 14.032 1.86l-.026.13c-1.825-.247-5.59-.534-9.955-.866-1.177-.09-2.398-.182-3.636-.279-5.824-.453-12.026-.982-15.847-1.602-6.154-1.014-12.172-2.84-17.916-4.755-1.488-.496-4.105-1.51-5.799-2.437l-.004-.002-.005-.004c-.344-.264-.85-.57-1.4-.905-.29-.176-.593-.36-.892-.55a13.678 13.678 0 01-1.212-.845C.6 1.448.3 1.155.12.865L0 .67zM.382 1c.168.207.394.418.658.63.353.283.77.565 1.2.837.292.185.591.367.88.542.554.337 1.068.649 1.418.917 1.684.92 4.29 1.93 5.773 2.425 5.742 1.914 11.751 3.737 17.894 4.75 3.815.618 10.01 1.147 15.836 1.6 1.237.097 2.456.19 3.633.28 3.35.254 6.35.482 8.391.687-2.766-.472-7.57-1.008-12.464-1.545l-.905-.1c-5.705-.624-11.367-1.245-13.884-1.759C15.859 7.624 11.343 6.183.382 1.001z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.19 15.964l-.495.18-.496.023-.473-.068-.495-.203-.473-.247-.473-.36-.45-.384-.429-.428-.428-.427-.405-.428-.383-.428-.338-.383-.338-.338-.292-.248-.27-.18-.226-.068h.18l.226.023.225.023.247.022.226.023.247.022.226.023.202.022.338.316.315.27.27.293.248.292.248.27.248.27.225.271.225.248.248.248.248.225.27.225.293.203.315.203.36.18.383.18.451.135z",
    fill: "url(#paint0_linear_1908_844)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.812 15.896l-.563.09-.541.023-.495-.045-.473-.135-.45-.18-.384-.226-.405-.247-.338-.316-.36-.315-.338-.338-.316-.36-.315-.36-.338-.36-.315-.339-.338-.338-.338-.292h.27l.136.022h.135l.158.023.135.022.157.023h.136l.135.022.157.023.158.022h.158l.157.023h.316l.157.022.113.18.135.226.203.27.18.27.248.293.247.315.27.316.27.293.294.292.27.27.315.248.293.203.27.18.293.113.293.067h.248z",
    fill: "url(#paint1_linear_1908_844)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.429 12.13h.349l.135.022h.135l.16.023.135.022.155.022h.136l.137.023.157.023.156.022h.158l.157.022h.316l.172.025.12.192.135.224.202.27.18.27.247.292.247.314.27.315.27.292.56.561.314.246.292.202.268.179.288.11.287.067h.245v.028l.004.029-.566.09-.545.023-.498-.046-.478-.136-.453-.181-.385-.227-.407-.25-.34-.316-.362-.317-.339-.339-.63-.72-.338-.36-.315-.338-.336-.336-.395-.343zm6.087 3.785l-.253-.059-.298-.114-.273-.182-.294-.204-.318-.25-.564-.564-.271-.294-.271-.316-.248-.315-.25-.295-.179-.27-.204-.271-.135-.225-.105-.17-.142-.02h-.316l-.157-.022h-.158l-.318-.045-.133-.023h-.135l-.16-.022-.135-.023-.155-.022h-.136l-.135-.023h-.19l.28.244.339.339.315.338.339.36.63.72.336.337.36.316.336.313.403.246.38.224.448.179.469.134.49.044.538-.022.27-.043z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.893 15.92l-.338.022-.316.045-.292-.023-.293-.045-.315-.067-.293-.113-.27-.158-.316-.202-.293-.203-.315-.27-.293-.316-.315-.337-.338-.406-.338-.45-.36-.496-.36-.54h.225l.203.022.225.023.203.022.202.023.225.022h.473l.226.203.18.225.203.226.202.225.18.225.203.248.18.203.203.247.18.226.203.225.203.225.202.203.225.202.226.18.225.203.248.18z",
    fill: "url(#paint2_linear_1908_844)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.794 12.332h.282l.203.023.225.022.203.023.202.022.224.023h.482l.235.211.182.227.406.45.18.226.202.247.18.203.203.248.18.225.404.449.202.202.224.201.226.181.224.202.246.179-.016.023.002.029-.337.022-.318.045-.298-.023-.294-.045-.318-.068-.297-.114-.273-.16-.316-.203-.295-.204-.318-.273-.293-.315-.316-.34-.339-.406-.338-.45-.36-.497-.39-.585zm5.018 3.564l-.186-.136-.225-.202-.226-.18-.226-.204-.204-.204-.406-.452-.18-.225-.203-.247-.18-.203-.203-.248-.18-.225-.202-.224-.204-.227-.178-.223-.216-.194h-.465l-.225-.023-.203-.022-.202-.023-.226-.022-.2-.023h-.17l.33.496.36.495.337.45.337.404.314.337.292.314.313.268.291.202.315.202.267.156.289.111.312.067.291.045.288.022.315-.045.259-.017z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.041 15.851l-.247.135-.293.045-.27-.022-.293-.113-.293-.18-.293-.248-.293-.247-.315-.316-.293-.338-.293-.337-.27-.338-.293-.338-.247-.315-.248-.293-.248-.248-.203-.203 1.397.136.157.202.18.203.158.225.158.203.158.202.157.203.158.225.18.203.18.203.18.203.18.202.226.203.203.18.225.203.248.18.247.18z",
    fill: "url(#paint3_linear_1908_844)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.573 12.46l1.488.143.164.212.182.204.157.225.474.609.156.224.719.808.224.202.203.18.224.202.494.36-.017.022.014.025-.252.138-.301.046-.278-.023-.3-.115-.296-.183-.59-.498-.316-.317-.586-.676-.27-.338-.293-.338-.248-.315-.246-.292-.506-.506zm4.415 3.388l-.462-.336-.225-.203-.202-.18-.228-.205-.723-.813-.157-.225-.473-.608-.157-.224-.18-.203-.15-.193-1.305-.127.146.147.25.25.248.293.247.315.293.338.27.337.585.675.314.314.583.493.288.178.287.11.263.022.284-.044.204-.111z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.361 15.559l-.405.248-.383.18-.383.09h-.36l-.36-.068-.338-.135-.338-.18-.316-.225-.315-.293-.315-.293-.293-.36-.315-.36-.293-.383-.27-.383-.293-.405-.27-.36.247.022.18.022h.136l.112.023.113.022h.293l.225.023.248.338.247.337.248.316.27.27.27.248.27.247.271.203.27.18.248.158.27.158.248.09.225.09.248.09.203.045.225.023.18.022z",
    fill: "url(#paint4_linear_1908_844)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.577 15.469l-.428.067-.405.023-.383-.023-.383-.067-.36-.068-.36-.113-.316-.157-.315-.18-.316-.203-.292-.225-.293-.248-.27-.27-.27-.293-.248-.315-.248-.316-.225-.338h.247l.293.023.27.045h.293l.225.023.203.022h.135l.068.023.022.022.068.068.112.112.136.135.135.158.18.18.203.18.225.226.248.202.27.225.248.203.292.226.293.18.316.18.315.158.315.135z",
    fill: "url(#paint5_linear_1908_844)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.411 12.715h.304l.295.023.268.044h.293l.226.023.2.023h.14l.078.026.027.027.317.317.134.157.179.178.203.181.224.224.247.202.27.225.248.203.29.224.292.18.314.179.314.156.315.135-.012.027.005.028-.431.068-.409.023-.386-.023-.383-.068-.364-.068-.362-.114-.319-.16-.316-.18-.318-.204-.294-.226-.294-.25-.271-.27-.272-.295-.497-.633-.255-.382zm5.064 2.74l-.226-.096-.317-.158-.316-.181-.295-.182-.293-.226-.248-.202-.27-.226-.25-.204-.225-.225-.203-.18-.182-.182-.134-.157-.134-.135-.18-.18-.018-.017-.057-.02h-.134l-.202-.022-.224-.022h-.294l-.271-.046-.29-.022h-.194l.195.293.494.628.27.292.269.269.29.246.292.225.314.201.314.18.312.156.357.111.358.068.382.067.38.022.401-.022.329-.052z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.176 15.559l-.337.067-.338.023-.36-.023-.36-.067-.361-.113-.338-.158-.338-.157-.338-.226-.315-.225-.315-.225-.293-.248-.293-.27-.27-.27-.27-.27-.248-.248-.226-.27h.158l.203.022h.428l.225.023.203.022.18.023.135.022v.023l.045.067.135.113.18.135.226.203.27.202.293.226.292.225.316.225.315.248.315.202.27.203.27.18.249.158.18.09.112.068z",
    fill: "url(#paint6_linear_1908_844)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.115 12.85h.222l.201.022h.43l.225.023.203.023.181.022.16.027v.038l.037.057.132.11.181.136.225.201.27.203.584.45.316.225.315.247.315.204.27.202.27.18.246.156.18.09.113.068-.015.025.006.028-.342.068-.341.023-.364-.024-.364-.068-.364-.114-.677-.316-.34-.227-.633-.452-.294-.249-.293-.27-.79-.79-.265-.318zm4.983 2.695l-.048-.029-.182-.09-.248-.159-.272-.181-.27-.202-.316-.204-.315-.247-.315-.226-.585-.45-.273-.204-.224-.202-.18-.135-.139-.115-.052-.079v-.007l-.11-.018-.18-.023-.202-.022-.224-.022h-.43l-.2-.023h-.096l.186.222.246.247.54.54.292.27.292.246.63.45.335.224.672.313.357.112.357.067.357.022.334-.022.263-.053z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.978 15.559l-.225.202-.27.09h-.338l-.383-.09-.428-.157-.428-.225-.45-.248-.45-.293-.451-.315-.406-.316-.405-.315-.338-.27-.293-.248-.225-.203-.158-.112-.067-.068.18.023h.18l.203.022.18.023.225.022h.203l.203.023h.225l.248.158.225.135.248.157.225.158.225.158.225.157.248.158.225.157.225.18.226.158.225.158.225.158.248.135.225.135.225.158.248.135z",
    fill: "url(#paint7_linear_1908_844)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.584 12.953l.26.032h.182l.203.023.18.023.224.022h.204l.201.022h.232l.255.162.225.136.249.158.675.473.248.158.227.158.224.18.674.472.248.134.226.137.224.156.247.135-.014.025.019.021-.23.207-.28.093h-.346l-.39-.091-.43-.16-.429-.225-.452-.249-.451-.293-.452-.316-.811-.631-.339-.271-.293-.248-.224-.202-.158-.113-.129-.128zm5.345 2.612l-.215-.118-.225-.157-.223-.134-.25-.137-.678-.474-.224-.18-.224-.156-.248-.158-.675-.473-.247-.157-.226-.135-.24-.153h-.22l-.202-.023h-.204l-.226-.023-.18-.022-.2-.022h-.183l-.097-.013.007.007.158.113.225.203.292.247.337.27.81.63.45.315.45.291.448.248.426.224.425.156.378.09h.33l.26-.088.19-.171z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.285 15.581l-.226.068-.225.045-.225.022-.225-.044-.226-.068-.225-.09-.248-.135-.27-.158-.293-.18-.292-.203-.338-.248-.36-.247-.406-.27-.428-.293-.473-.316-.518-.338.203.023h.473l.225.023h.203l.157.022.113.023h.023l.045.045.067.067.113.113.157.135.203.18.225.203.225.18.293.225.27.203.293.203.293.18.293.202.293.158.293.113.27.09.248.067z",
    fill: "url(#paint8_linear_1908_844)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.291 13.15l.019-.052.201.022h.474l.224.023h.203l.162.023.11.022h.031l.053.053.18.18.157.134.203.18.225.203.224.18.292.224.27.202.292.202.293.18.292.203.29.156.29.111.269.09.247.067-.008.028.008.027-.227.069-.228.045-.23.023-.232-.046-.227-.069-.229-.091-.248-.136-.271-.158-.294-.181-.294-.203-.337-.248-.36-.247-.405-.27-.428-.293-.473-.315-.518-.338zm4.89 2.432l-.153-.041-.272-.09-.296-.115-.296-.16-.292-.202-.293-.18-.294-.204-.27-.203-.294-.225-.226-.181-.225-.203-.203-.18-.159-.136-.18-.18-.037-.037h-.013l-.115-.023-.155-.022h-.203l-.224-.023h-.475l-.083-.01.418.273.473.316.428.292.405.27.361.249.338.248.292.202.292.18.27.156.245.135.223.088.222.067.22.044.22-.022.222-.044.128-.039z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.23 15.424l-.292.135-.316.045-.36-.022-.338-.09-.383-.136-.338-.18-.383-.203-.337-.225-.316-.247-.315-.248-.293-.225-.247-.248-.226-.203-.18-.158-.135-.112-.068-.09.203.022h.203l.203.023.18.022.202.023h.18l.226.022.202.023.158.135.18.158.135.135.18.158.18.18.158.157.18.158.203.158.18.135.18.135.203.135.18.113.203.112.203.09.203.068.202.045z",
    fill: "url(#paint9_linear_1908_844)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.64 13.18l.267.03h.205l.203.023.18.022.2.023h.182l.226.022.211.024.165.14.181.16.135.134.18.159.338.337.179.156.202.157.359.27.202.134.179.112.2.112.201.089.2.067.201.044-.006.028.012.026-.296.137-.323.046-.366-.023-.343-.091-.385-.136-.34-.181-.385-.204-.34-.227-.63-.495-.295-.228-.247-.247-.225-.202-.18-.157-.137-.115-.11-.146zm4.501 2.253l-.123-.027-.205-.069-.205-.091-.204-.114-.18-.113-.205-.136-.36-.27-.204-.16-.182-.158-.158-.158-.18-.18-.18-.158-.135-.134-.179-.157-.15-.13-.194-.02-.224-.023h-.182l-.203-.023-.18-.022-.201-.023h-.204l-.137-.015.026.034.133.111.18.158.227.204.246.246.291.225.63.495.336.223.382.202.336.18.38.133.333.09.355.022.308-.044.212-.098z",
    fill: "#231F20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.401 15.063l-.27.18-.27.113-.248.067h-.27l-.27-.045-.248-.09-.27-.112-.248-.158-.27-.158-.248-.225-.248-.203-.248-.225-.247-.225-.248-.225-.225-.225-.248-.203h.158l.135.022.18.023.18.022.203.023h.203l.225.022.225.023.045.158.09.157.113.135.112.158.135.135.136.113.135.135.18.113.18.112.18.09.203.09.18.068.225.045.203.045.225.022.225.023z",
    fill: "url(#paint10_linear_1908_844)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.245 13.3h.24l.137.023.36.045.2.022h.204l.47.047.05.174.087.152.112.135.111.156.133.132.136.114.133.132.356.223.179.09.2.089.178.066.224.045.2.045.45.045-.004.028.016.024-.272.182-.276.115-.252.068h-.276l-.276-.046-.251-.091-.273-.114-.249-.159-.272-.158-.25-.227-.248-.203-.744-.677-.224-.224-.31-.253zm4.074 1.784l-.374-.038-.203-.045-.227-.045-.184-.07-.204-.09-.182-.091-.363-.228-.137-.136-.136-.113-.137-.137-.113-.159-.113-.136-.093-.163-.041-.142-.43-.043h-.204l-.203-.023-.18-.023-.182-.022-.133-.023h-.075l.188.154.225.225.495.45.247.225.248.203.246.223.268.157.246.156.267.112.245.089.265.044h.264l.243-.066.266-.111.201-.134z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.438 14.86l-.226.09-.248.068-.247.045h-.27l-.27-.022-.271-.023-.293-.09-.27-.068-.27-.135-.248-.112-.225-.158-.203-.158-.18-.18-.158-.202-.112-.226-.09-.225.157.023h.158l.18.022.158.023h.18l.18.022.203.023h.225l.09.135.113.135.09.113.112.112.09.09.136.09.112.09.113.068.135.068.135.067.158.068.157.067.158.045.158.045.202.045.18.046z",
    fill: "url(#paint11_linear_1908_844)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.812 13.429l.204.029h.16l.18.023.156.022h.181l.18.023.201.022h.24l.097.147.112.134.089.111.2.2.134.09.111.089.11.066.269.134.313.134.313.09.202.045.18.045-.007.027.011.027-.228.091-.25.068-.25.046h-.276l-.544-.046-.294-.09-.273-.069-.273-.136-.25-.113-.228-.16-.205-.16-.183-.183-.16-.205-.114-.23-.108-.271zm3.533 1.438l-.094-.024-.204-.045-.32-.091-.316-.136-.135-.068-.137-.068-.116-.07-.111-.09-.137-.09-.207-.208-.09-.112-.114-.137-.081-.123h-.214l-.203-.023-.178-.022h-.18l-.16-.023-.178-.022h-.158l-.11-.016.07.178.111.222.155.2.178.177.2.156.223.156.247.112.267.133.269.068.29.089.536.044h.266l.244-.044.245-.067.142-.056z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.978 14.68l-.09.09-.113.045-.157.023h-.158l-.18-.023-.18-.022-.226-.068-.202-.067-.203-.09-.225-.113-.203-.113-.18-.135-.18-.135-.158-.157-.135-.158-.09-.18.112.022h.113l.113.023.135.022h.112l.113.023h.18v.045l.113.112.203.136.247.18.316.157.315.18.315.136.293.067z",
    fill: "url(#paint12_linear_1908_844)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.246 13.537l.167.033h.113l.115.024.132.022h.113l.113.022h.206v.062l.102.102.201.134.246.18.315.157.314.179.311.133.29.067-.006.028.02.02-.094.095-.121.048-.163.024h-.164l-.362-.046-.229-.069-.205-.068-.204-.09-.226-.114-.206-.114-.362-.272-.16-.16-.138-.161-.118-.236zm2.675 1.16l-.245-.057-.32-.138-.315-.18-.317-.158-.249-.181-.204-.136-.123-.123v-.029h-.155l-.112-.022h-.113l-.138-.023-.11-.022h-.112l-.058-.012.062.125.132.154.156.155.357.268.2.112.224.112.201.089.201.067.222.067.357.044h.154l.152-.021.104-.042.05-.05z",
    fill: "#231F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.339 14.32l-.023.18-.068.113-.09.045-.157.045-.158-.045-.203-.045-.202-.09-.203-.113-.203-.112-.202-.136-.203-.112-.158-.135-.135-.09-.113-.09-.067-.045v-.023l1.013.113.09.045.113.067.158.09.18.068.18.09.18.067.158.068.113.045z",
    fill: "url(#paint13_linear_1908_844)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.125 13.635l1.05.117.097.048.113.067.155.09.18.067.18.09.18.067.157.067.112.045-.01.027.028.003-.023.187-.075.124-.1.05-.168.049-.165-.048-.205-.045-.207-.092-.408-.227-.201-.134-.205-.114-.158-.136-.136-.09-.111-.09-.08-.052v-.07zm2.182.703l-.092-.037-.157-.067-.183-.069-.179-.09-.18-.067-.16-.091-.112-.067-.085-.043-.932-.103.012.008.112.09.137.09.155.134.202.112.202.135.403.224.2.088.2.045.15.043.148-.042.08-.04.06-.1.02-.153z",
    fill: "#231F20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.167 13.78h.225l.203.022.18.023h.158l.158.022h.18l.18.045.18.023-.022.247-.136.136h-.18l-.225-.068-.248-.135-.247-.113-.226-.135-.18-.067z",
    fill: "url(#paint14_linear_1908_844)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.325 13.808l.035.013.226.136.248.113.245.133.219.066h.164l.12-.12.018-.21-.156-.019-.177-.044h-.178l-.158-.023h-.16l-.18-.022-.2-.023h-.066zm-.158-.028v-.029h.229l.203.023.178.022h.158l.158.023h.181l.182.045.206.026-.026.285-.15.151h-.197l-.232-.07-.25-.136-.25-.113-.222-.134-.178-.067.01-.026z",
    fill: "#231F20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.212 13.645l.226.045.18.022.18.045.18.023.158.045.157.022.18.045.18.045.023-.27-.112-.203-.18-.045-.248-.022-.27.045-.27.067-.226.09-.158.046z",
    fill: "url(#paint15_linear_1908_844)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.135 13.368l.253.023.195.048.123.222-.026.312-.392-.098-.16-.023-.156-.045-.181-.022-.178-.045-.181-.023-.225-.045.005-.028-.007-.027.156-.045.227-.09.273-.069.274-.045zm-.801.271l.108.022.183.023.178.045.18.022.159.045.158.023.328.082.02-.228-.103-.184-.166-.042-.242-.022-.266.045-.267.066-.226.09-.044.013z",
    fill: "#231F20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.564 8.307l-.586-.203-.54-.158-.519-.045-.495.045-.473.09-.428.158-.405.225-.406.248-.405.293-.383.315-.383.338-.36.338-.36.315-.383.316-.36.315-.384.27.136.023.157.022h.135l.135.045h.136l.157.023h.158l.135.022h.135l.158.023.157.022.158.023h.158l.157.022.158.023.158.022.135-.18.18-.225.18-.248.248-.27.248-.293.27-.293.315-.292.293-.27.338-.27.315-.226.338-.203.338-.18.315-.135.338-.068.315-.022.316.045z",
    fill: "url(#paint16_linear_1908_844)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.92 7.872l.523.046.544.159.586.202-.01.027-.003.029-.313-.045-.31.022-.333.067-.312.133-.336.18-.336.201-.314.225-.336.269-.292.27-.315.291-.269.292-.248.293-.246.269-.18.248-.18.224-.146.194-.487-.07h-.158l-.473-.067h-.135l-.135-.023h-.158l-.157-.023h-.138l-.135-.045h-.133l-.16-.023-.204-.034.439-.309.36-.315.382-.315.36-.315.36-.338.384-.338.384-.317.407-.294.407-.248.407-.226.432-.16.479-.09.498-.046zm1.353.364l-.304-.105-.537-.157-.512-.044-.492.044-.47.09-.423.156-.403.224-.404.247-.404.291-.381.315-.383.337-.36.338-.361.316-.383.315-.362.317-.326.23.066.011.155.022h.138l.135.045h.133l.157.023h.158l.136.022h.134l.473.068h.158l.458.065.126-.167.18-.225.181-.25.248-.27.248-.293.272-.294.315-.293.294-.271.34-.272.316-.226.34-.203.34-.182.318-.136.344-.069.318-.022.024.003z",
    fill: "#231F20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.555 8.531l-.338-.112-.315-.068-.293-.067-.315-.023-.316.023-.315.067-.293.09-.315.158-.338.18-.315.225-.338.293-.36.316-.383.382-.383.428-.406.496-.427.54h.225l.225.045h.18l.203.023.18.023.18.044.225.023.27.045.248-.203.203-.202.248-.226.203-.225.225-.225.225-.225.203-.225.225-.203.225-.225.248-.18.203-.203.247-.203.248-.18.27-.135.248-.135.293-.136z",
    fill: "url(#paint17_linear_1908_844)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.294 8.233l.32.023.294.068.318.068.338.113-.01.027.013.026-.292.135-.248.135-.268.134-.245.178-.246.201-.203.204-.248.18-.225.225-.224.201-.203.225-.45.45-.204.227-.247.225-.204.204-.258.21-.282-.046-.227-.023-.18-.045-.178-.022-.201-.023h-.182l-.225-.045h-.282l.465-.587.407-.496.383-.43.385-.384.36-.315.34-.295.319-.227.338-.18.318-.159.297-.091.317-.068.32-.023zm1.183.303l-.267-.09-.315-.066-.29-.068-.311-.022-.312.023-.312.066-.29.09-.312.156-.336.179-.313.223-.336.292-.36.315-.381.381-.382.427-.405.495-.391.494h.169l.225.045h.18l.203.023.184.023.178.045.225.022.258.043.236-.194.203-.202.247-.224.202-.226.45-.45.204-.226.225-.203.227-.226.247-.18.203-.203.25-.204.25-.181.271-.136.25-.136.226-.105z",
    fill: "#231F20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.636 8.824l-.248-.202-.27-.113-.293-.022-.315.067-.315.135-.338.18-.338.226-.338.292-.338.293-.338.316-.337.315-.316.338-.292.293-.27.27-.249.248-.247.202 1.441.158.18-.203.18-.225.158-.203.203-.203.18-.225.18-.202.203-.226.18-.202.203-.18.203-.203.225-.18.247-.18.248-.158.248-.158.293-.135.27-.113z",
    fill: "url(#paint18_linear_1908_844)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.823 8.458l.302.023.278.116.25.206-.017.022.01.026-.269.112-.29.135-.494.313-.246.18-.224.178-.202.203-.202.18-.179.2-.203.226-.18.202-.181.227-.202.202-.156.201-.181.226-.19.214-1.524-.166.299-.245.81-.81.316-.339.676-.631.679-.588.34-.227.34-.18.318-.137.322-.069zm.758.359l-.208-.17-.262-.11-.284-.021-.309.066-.311.133-.336.18-.335.223-.674.584-.674.63-.316.337-.813.813-.195.16 1.36.148.17-.191.179-.224.16-.206.201-.201.18-.225.18-.203.203-.225.183-.206.202-.179.204-.204.227-.181.249-.181.499-.318.294-.135.226-.094z",
    fill: "#231F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.798 9.748l-.383-.383-.383-.27-.383-.18-.36-.113-.36-.022-.36.067-.361.135-.338.158-.338.248-.338.27-.337.315-.316.338-.315.36-.315.383-.316.383-.315.36.248.023.203.023h.18l.157.022.158.045.158.023.202.022.248.045.27-.36.248-.315.293-.293.248-.248.292-.203.248-.202.248-.158.27-.113.248-.112.225-.09.27-.045.226-.068.225-.022.225-.023h.428z",
    fill: "url(#paint19_linear_1908_844)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.927 8.75l.367.024.367.115.386.181.387.273.384.385-.02.02v.029h-.427l-.446.044-.226.068-.267.044-.222.089-.248.113-.268.111-.244.156-.248.203-.291.201-.538.538-.246.313-.28.374-.265-.048-.203-.022-.161-.023-.156-.045-.154-.022h-.18l-.203-.023-.304-.027.352-.402.631-.767.316-.36.317-.34.34-.317.338-.27.34-.25.343-.16.362-.136.367-.068zm1.802.97l-.332-.333-.38-.267-.378-.179-.355-.11-.354-.023-.354.067-.357.134-.334.156-.335.245-.337.27-.336.313-.315.337-.314.36-.631.766-.279.318.193.018.201.022h.18l.164.023.156.045.155.022.204.023.23.042.26-.347.25-.318.543-.542.294-.204.25-.204.25-.159.272-.113.248-.113.228-.091.272-.045.226-.068.456-.046h.359z",
    fill: "#231F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M48.33 10.086l-.428-.158-.406-.113-.405-.067-.383-.023h-.383l-.36.068-.36.067-.339.113-.337.158-.316.18-.338.203-.292.247-.316.248-.27.293-.293.315-.27.338.27.045.316.045.315.045.315.023.293.045.225.022.18.023h.068l.023-.023.067-.067.09-.09.113-.113.135-.135.18-.158.203-.157.225-.203.248-.158.247-.18.293-.18.316-.158.315-.157.338-.136.36-.112.36-.09z",
    fill: "url(#paint20_linear_1908_844)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.323 9.697h.387l.386.022.408.069.408.113.428.158-.01.027.007.027-.36.09-.358.112-.336.134-.629.315-.29.179-.249.18-.245.157-.225.202-.202.157-.18.157-.404.404-.03.031h-.084l-.18-.022-.226-.023-.292-.045-.316-.023-.631-.09-.319-.053.303-.377.292-.316.272-.294.317-.249.294-.249.34-.204.318-.181.34-.16.342-.113.724-.135zm1.91.383l-.34-.125-.403-.112-.402-.067-.38-.022h-.38l-.716.134-.335.111-.335.157-.314.18-.336.2-.291.248-.314.246-.269.291-.292.315-.239.299.222.037.63.09.316.022.292.045.225.023.178.022h.054l.421-.42.182-.16.202-.157.226-.203.249-.159.249-.18.295-.182.633-.316.34-.136.361-.113.27-.068z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.266 10.333l-.337-.135-.36-.112-.384-.046h-.36l-.383.046-.383.067-.36.135-.383.135-.36.18-.36.18-.339.226-.337.225-.293.225-.316.248-.27.248-.247.248.18.022.202.023.226.022.247.023.27.045.203.022h.36v-.022l.046-.068.135-.09.203-.135.225-.135.292-.18.316-.18.315-.18.338-.18.338-.181.338-.18.315-.158.293-.135.247-.09.226-.068.157-.045z",
    fill: "url(#paint21_linear_1908_844)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.825 10.012h.364l.385.045.365.115.338.135-.01.026.007.028-.157.045-.224.067-.246.09-.292.134-.314.157-1.013.54-.63.36-.292.18-.225.135-.333.222-.037.056v.042h-.392l-.204-.023-.27-.045-.246-.022-.226-.023-.203-.022-.238-.03.29-.29.272-.25.315-.247.295-.227.678-.452.724-.362.383-.135.363-.135.387-.069.386-.045zm-2.37 2.32v-.003l.052-.08.344-.229.225-.134.293-.181.632-.36 1.014-.542.316-.158.295-.136.25-.09.224-.068.078-.022-.259-.104-.357-.111-.378-.045h-.357l-.38.045-.38.067-.359.134-.38.135-.718.359-.674.449-.291.224-.315.247-.269.247-.206.206.122.015.202.022.225.023.25.022.27.046.2.022h.33z",
    fill: "#231F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.113 10.716l-.18-.292-.27-.18-.36-.046h-.383l-.428.09-.473.136-.496.202-.495.225-.496.248-.45.248-.45.27-.384.248-.337.203-.248.157-.158.113-.09.045.18.045.225.022.226.023.225.022.248.023.247.023.248.045.225.022.248-.113.248-.112.248-.135.225-.135.248-.113.225-.135.248-.135.247-.135.225-.113.248-.135.248-.113.225-.112.248-.113.248-.09.247-.113.248-.09z",
    fill: "url(#paint22_linear_1908_844)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.917 10.17h.39l.366.046.281.187.184.298-.025.015.01.027-.247.09-.248.113-.247.09-.246.112-.226.113-.247.112-.248.135-.224.112-.495.27-.227.136-.247.112-.225.135-.25.136-.502.229-.235-.024-.246-.045-.494-.045-.678-.067-.258-.065.157-.078.158-.113.248-.158.337-.202.384-.248.451-.27.452-.25.496-.247.496-.226.499-.204.475-.135.43-.091zm1.154.532l-.159-.258-.26-.173-.351-.044h-.378l-.424.09-.47.134-.494.202-.495.224-.494.248-.45.247-.45.27-.383.248-.337.202-.247.157-.159.114-.023.011.103.026.674.067.498.046.246.044.217.022.487-.221.246-.135.228-.136.246-.112.225-.135.497-.27.224-.113.25-.136.247-.112.226-.113.25-.114.246-.09.249-.112.215-.078z",
    fill: "#231F20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M54.456 11.347l-.293-.225-.316-.113-.337-.045h-.383l-.383.068-.383.113-.383.135-.383.18-.338.202-.36.18-.315.226-.27.18-.248.18-.203.158-.158.09-.067.068.202.022.203.023.18.045h.158l.18.022.18.023.203.022.203.023.18-.113.18-.112.203-.158.203-.135.202-.135.203-.136.225-.157.203-.135.203-.113.225-.113.225-.112.203-.068.225-.067.225-.045h.203l.203.022z",
    fill: "url(#paint23_linear_1908_844)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.124 10.935h.39l.34.046.323.115.296.228-.017.023-.004.029-.2-.023h-.199l-.221.044-.224.067-.2.067-.448.224-.201.112-.202.134-.225.158-.607.405-.205.159-.369.23-.415-.046-.359-.045h-.16l-.18-.045-.463-.052.112-.112.16-.091.2-.157.25-.18.27-.18.316-.227.362-.18.339-.204.386-.182.384-.135.386-.114.385-.068zm1.233.372l-.208-.16-.308-.11-.333-.044h-.379l-.379.067-.38.112-.381.134-.38.179-.339.203-.358.18-.314.224-.27.18-.247.179-.204.159-.156.089-.023.023.35.038.177.045h.158l.36.045.395.044.35-.22.204-.157.608-.405.225-.158.205-.137.204-.113.452-.226.206-.068.227-.069.228-.045h.209l.101.011z",
    fill: "#231F20"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6 10.964l-.225-.157-.248-.09-.225-.068-.226-.022-.225.022-.27.045-.27.09-.293.113-.316.135-.315.158-.36.202-.406.203-.427.225-.473.248-.518.248-.563.27.225.022.225.023.225.022.248.045.203.023.157.023.135.022.045-.022.023-.023.09-.068.113-.112.157-.113.203-.135.248-.157.248-.18.27-.158.293-.18.315-.18.315-.136.338-.135.315-.113.338-.067.316-.023h.315z",
    fill: "url(#paint24_linear_1908_844)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.676 10.597l.231.024.23.068.25.092.23.16-.017.023v.029h-.315l-.312.022-.334.067-.313.111-.337.135-.313.135-.314.179-.293.18-.269.157-.248.18-.247.158-.202.134-.156.111-.112.113-.09.067-.025.025-.057.029-.144-.024-.157-.023-.204-.023-.247-.045-.776-.077.655-.314.518-.248.472-.248.429-.225.404-.202.361-.203.317-.159.317-.135.294-.113.272-.091.274-.046.228-.023zm.833.338l-.148-.103-.243-.089-.222-.066-.22-.022-.221.022-.267.045-.268.089-.291.112-.314.134-.314.157-.361.204-.406.202-.427.225-.474.248-.518.248-.471.226.576.058.247.045.203.022.158.023.126.021.032-.016.021-.02.09-.068.113-.113.16-.115.204-.135.247-.158.249-.18.27-.158.293-.18.319-.182.316-.136.338-.135.318-.114.343-.068.318-.023h.224z",
    fill: "#231F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M55.514 12l-.248-.248-.247-.202-.248-.135-.248-.068-.27-.022-.27.022-.293.068-.27.09-.293.157-.27.135-.293.18-.293.18-.293.204-.27.18-.27.202-.27.18.134.023h.18l.203.045.203.023.225.022.248.045.203.023.225.022.09-.18.09-.135.113-.158.112-.112.135-.136.158-.09.158-.09.18-.067.18-.068.203-.067.18-.023.225-.022.225-.023h.203l.225.023.248.022z",
    fill: "url(#paint25_linear_1908_844)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.253 11.296l.275.023.253.069.254.138.252.206.247.248-.02.02-.003.028-.247-.022-.225-.022h-.2l-.448.044-.177.023-.2.066-.357.134-.31.177-.244.244-.11.155-.09.133-.097.197-.246-.025-.204-.023-.247-.045-.224-.022-.206-.023-.2-.044h-.18l-.208-.035.33-.22.27-.203.27-.18.295-.204.587-.361.27-.135.295-.159.275-.092.295-.067.275-.023zm1.185.668l-.191-.19-.245-.2-.242-.133-.242-.066-.265-.022-.266.022-.29.067-.266.089-.292.157-.269.134-.584.36-.292.202-.27.18-.27.203-.21.14.06.01h.182l.204.046.2.022h.001l.227.023.247.045.201.022.206.02.083-.165.09-.136.115-.16.252-.252.32-.183.364-.136.205-.069.184-.022.453-.046h.206l.225.023.169.015z",
    fill: "#231F20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.136 12.878l-.068-.112-.112-.09-.136-.09-.157-.046-.203-.045h-.653l-.225.045-.226.068-.225.067-.203.09-.202.113-.18.135-.158.136-.113.157.113.023.135.022.158.023.135.045h.135l.113.022h.09l.067-.022.113-.09.225-.113.27-.112.293-.09.338-.113.338-.045.338.022z",
    fill: "url(#paint26_linear_1908_844)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.804 12.467h.66l.206.046.163.046.14.094.117.093.07.118-.024.014-.002.029-.335-.023-.333.045-.336.112-.29.09-.269.111-.222.111-.114.091-.077.026h-.097l-.113-.023h-.137l-.137-.045-.156-.022-.136-.023-.156-.031.14-.197.162-.138.184-.138.205-.114.206-.091.453-.136.228-.045zm1.279.38l-.037-.062-.107-.086-.13-.087-.153-.044-.2-.044h-.646l-.221.044-.448.135-.2.088-.2.111-.178.134-.154.132-.085.119.07.014.133.022.16.023.134.044h.133l.112.023h.083l.058-.02.111-.088.23-.115.273-.114.292-.09.34-.113.344-.046.286.02z",
    fill: "#231F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.451 13.42v-.226l-.045-.158-.09-.09-.158-.067-.157-.045-.203.022-.203.023-.247.067-.226.068-.225.09-.203.067-.18.09-.157.068-.136.045-.067.068h-.023l1.059.18.09-.023.135-.045.158-.045.18-.067.18-.023.203-.045h.157l.158.045z",
    fill: "url(#paint27_linear_1908_844)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.003 12.804l.167.048.162.07.1.1.048.168v.23h-.029l-.008.027-.154-.044h-.15l-.202.045-.177.022-.18.067-.157.044-.136.046-.096.024-1.065-.181.005-.057h.01l.065-.064.14-.047.156-.066.181-.091.204-.068.227-.09.226-.069.25-.068.413-.046zm-1.793.622l.979.167.083-.021.135-.045.157-.045.182-.068.182-.023.205-.046h.164l.126.036v-.183l-.043-.147-.08-.08-.151-.066-.15-.042-.398.044-.246.067-.223.067-.226.09-.2.067-.18.09-.16.068-.13.043-.026.027z",
    fill: "#231F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M56.573 12.541l-.203-.18-.225-.135-.248-.113-.27-.09-.293-.045-.27-.045h-.293l-.293.045-.27.045-.27.09-.248.113-.248.112-.203.18-.202.18-.136.203-.112.226.157.022.158.023.18.022.18.023.18.022.203.023.203.022.225.045.09-.135.09-.09.09-.09.136-.09.112-.09.158-.068.135-.067.158-.068.157-.045.18-.045.158-.023.158-.022h.518l.158.045z",
    fill: "url(#paint28_linear_1908_844)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.769 11.904h.297l.272.045.295.046.276.091.25.114.228.137.205.182-.02.021-.007.028-.154-.044h-.512l-.312.045-.178.044-.155.045-.156.066-.136.068-.154.066-.111.09-.133.088-.176.176-.1.149-.242-.049-.405-.045-.54-.067-.355-.051.132-.264.137-.206.411-.365.502-.229.273-.09.273-.046.295-.045zm1.69.575l-.106-.095-.222-.133-.245-.112-.266-.089-.29-.044-.269-.045h-.288l-.29.045-.268.044-.267.09-.246.111-.244.111-.2.177-.2.178-.132.198-.094.188.276.04.54.067.408.046.206.041.081-.122.092-.092.092-.092.137-.09.115-.092.16-.07.136-.067.16-.07.16-.044.183-.046.317-.045h.524l.04.011z",
    fill: "#231F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.862 6.257l-.023.045-.067.09-.09.18-.113.203-.135.248-.135.292-.113.316-.113.315-.067.315-.023.316v.315l.068.293.158.27.225.225.315.18.406.136-.068-.203-.045-.203-.045-.203-.023-.247-.022-.226v-.247l.022-.248.023-.248.022-.248.023-.247.045-.248.045-.225.045-.203.045-.203.068-.202.045-.158-.068-.045h-.045l-.067-.023-.045-.022-.068-.023-.045-.022-.068-.023-.067-.022z",
    fill: "url(#paint29_linear_1908_844)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87 6.23l.138.045.045.023.067.022.045.023.062.02h.049l.092.062-.051.179-.068.2-.09.404-.044.225-.045.246-.09.989v.245l.023.224.022.246.09.402.085.255-.463-.154-.32-.183-.231-.23-.162-.278-.07-.3v-.32l.023-.318.07-.32.225-.634.136-.294.136-.248.112-.202.091-.182.068-.09.021-.043.026.013.009-.028zm.006.062l-.013.025-.067.09-.09.179-.112.202-.135.247-.134.291-.224.628-.067.311-.022.312v.311l.066.286.153.263.22.22.31.177.348.116-.05-.151-.091-.41-.022-.247-.023-.228v-.25l.09-.994.046-.248.045-.226.09-.408.068-.202.04-.137-.044-.029h-.04l-.075-.024-.045-.023-.067-.022-.045-.023-.11-.036z",
    fill: "#231F20"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.312 6.437l-.18.72-.135.654-.068.563v.495l.023.45.067.361.113.316.113.27.157.203.18.157.158.135.18.09.18.068.158.022h.27l-.067-.202-.09-.203-.068-.248-.045-.225-.045-.27-.045-.248-.045-.27-.023-.27-.022-.293v-.27l.022-.293.023-.27.045-.293.045-.27.068-.27.09-.271-.158-.068-.158-.045-.157-.045-.136-.045-.112-.045-.135-.045-.113-.022-.09-.023z",
    fill: "url(#paint30_linear_1908_844)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.409 6.432l.115.023.137.045.111.045.134.045.318.09.182.079-.098.294-.067.268-.045.27-.045.29-.022.27-.022.292v.268l.022.291.022.27.045.268.045.248.045.27.045.224.067.244.09.204.08.24h-.312l-.163-.023-.186-.07-.183-.092-.16-.137-.183-.16-.161-.208-.115-.275-.113-.317-.069-.367-.022-.452V8.37l.068-.565.135-.654.18-.721.028.007.007-.028.09.023zm-.076.04l-.173.692-.135.651-.067.56v.494l.022.447.067.357.112.312.11.266.154.198.178.155.155.133.176.088.176.066.152.022h.229l-.055-.164-.09-.203-.069-.252-.045-.226-.045-.27-.045-.248-.046-.273-.022-.27-.023-.295v-.273l.023-.293.023-.272.045-.293.045-.273.068-.272.082-.245-.132-.057-.314-.09-.137-.045-.112-.045-.133-.044-.112-.023-.062-.015z",
    fill: "#231F20"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.37 6.775l-.067.248-.09.338-.045.36-.023.405-.022.45v.451l.045.45.067.429.09.405.113.383.18.315.203.27.248.203.292.09.316.023.383-.113-.135-.225-.158-.248-.113-.27-.112-.248-.068-.27-.09-.27-.045-.27-.045-.27-.045-.294v-.563l.022-.27.023-.293.045-.27.068-.293.067-.292-.135-.046-.158-.045L12.024 7l-.158-.067-.158-.045-.112-.045-.135-.045-.09-.023z",
    fill: "url(#paint31_linear_1908_844)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.377 6.747l.093.023.136.046.112.045.16.045.155.067.315.09.16.054-.141.61-.045.268-.022.291-.023.27v.56l.045.29.09.538.09.27.067.268.112.246.111.268.157.246.154.257-.423.125-.324-.023-.301-.093-.255-.209-.207-.275-.181-.319-.115-.388-.09-.407-.068-.43-.045-.453v-.452l.023-.45.022-.408.046-.364.09-.338.068-.247.027.007.007-.028zm.014.063l-.06.22-.09.336-.045.358-.022.404-.023.45v.448l.045.448.068.426.09.404.11.379.178.31.2.267.24.197.285.087.307.022.342-.1-.116-.194-.159-.25-.113-.272-.114-.25-.067-.271-.09-.271-.091-.543-.046-.295v-.568l.023-.27.023-.295.045-.272.13-.56-.11-.037-.319-.091-.156-.067-.158-.046-.112-.044-.133-.045-.062-.015z",
    fill: "#231F20"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.704 12.203l-.338.022-.36-.045-.293-.135-.27-.18-.27-.248-.226-.293-.18-.337-.158-.383-.135-.406-.112-.45-.068-.428-.023-.45v-.451l.045-.45.068-.428.113-.406.157.045.136.068.157.022.158.068.157.045.18.045.158.068.158.045v.585l.023.338v.338l.022.36.022.36.023.383.045.36.068.361.045.316.067.315.09.293.113.225.135.202.135.136.158.09z",
    fill: "url(#paint32_linear_1908_844)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.477 7.1l.188.054.133.066.157.023.16.068.155.045.182.045.158.068.176.05v.607l.023.338v.337l.045.72.022.382.045.359.068.36.045.315.067.313.089.29.11.22.133.2.13.13.155.088-.014.025.002.029-.34.022-.368-.046-.3-.138-.273-.182-.274-.251-.228-.297-.183-.342-.158-.385-.136-.407-.113-.453-.068-.431-.022-.452v-.454l.045-.452.068-.43.12-.434zm2.13 5.08l-.079-.044-.14-.14-.138-.208-.114-.228-.091-.297-.068-.317-.045-.315-.068-.361-.045-.363-.022-.382-.045-.723v-.337l-.023-.339v-.564l-.14-.04-.156-.067-.179-.044-.16-.046-.155-.067-.158-.022-.137-.069-.128-.036-.104.376-.067.426-.045.448v.448l.022.448.068.425.111.448.135.404.157.38.178.335.222.289.267.245.267.177.287.133.353.044.24-.016z",
    fill: "#231F20"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.78 7.54l.136.068.135.045.112.023.136.022.112.045.135.046.135.045.113.045.022.27.023.27.023.315v1.014l.022.36v.338l.045.338.023.338.067.315.068.293.112.27.113.27.158.203.18.158-.383-.09-.315-.113-.27-.203-.226-.202-.18-.248-.135-.293-.113-.315-.067-.316-.068-.382-.045-.383v-.383l-.022-.428V8.87l-.023-.428v-.45l-.023-.451z",
    fill: "url(#paint33_linear_1908_844)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.812 7.588l.02.403v.45l.022.429v.404l.023.43v.38l.044.38.068.382.067.313.111.313.134.289.177.243.222.2.265.199.31.11.27.064-.096-.084-.162-.208-.228-.546-.068-.296-.068-.317-.022-.339-.046-.34v-.338l-.022-.36V8.735l-.022-.314-.044-.523-.095-.038-.135-.045-.137-.046-.11-.044-.132-.022-.116-.023-.137-.046-.093-.047zm-.031-.047l.012-.026.134.067.131.044.11.022.138.023.115.046.134.045.137.045.13.052.046.558.022.318v1.012l.023.361v.336l.045.338.022.336.067.313.067.29.223.535.154.198.178.155-.026.05-.386-.091-.319-.114-.276-.207-.227-.205-.184-.252-.137-.298-.114-.319-.068-.316-.067-.385-.046-.386v-.382l-.022-.429v-.404l-.023-.43v-.449l-.022-.45.028-.001z",
    fill: "#231F20"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.249 13.149l-.518-.023-.45-.112-.361-.158-.293-.225-.248-.293L15.2 12l-.135-.36-.09-.406-.045-.428-.045-.428-.023-.45V8.644l-.022-.405-.023-.36.135.044.136.023.112.045.135.045.136.045.112.023.135.045.158.022-.023.045-.022.09-.023.158-.045.18-.022.225-.023.27-.022.293.022.338.023.36.067.406.136.405.135.406.202.45.27.45.316.451.383.45z",
    fill: "url(#paint34_linear_1908_844)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.785 7.838l.174.058.136.023.114.045.268.09.114.023.133.044.194.028-.038.078-.022.085-.023.16-.044.177-.023.223-.022.27-.022.29.022.337.022.359.067.401.27.808.2.447.27.448.314.449.382.45-.022.018-.001.029-.521-.023-.456-.114-.366-.16-.297-.23-.252-.297-.184-.344-.135-.362-.091-.41-.09-.858-.023-.452V8.645l-.022-.404-.026-.403zm2.4 5.28l-.342-.403-.317-.452-.272-.454-.203-.453-.271-.813-.069-.41-.022-.36-.023-.34.023-.295.022-.271.023-.227.046-.181.022-.16.024-.092.006-.013-.121-.017-.136-.045-.114-.023-.272-.091-.11-.044-.134-.022-.097-.033.02.318.022.407v1.283l.023.45.09.853.089.402.134.356.177.334.244.288.288.221.355.156.445.11.45.02z",
    fill: "#231F20"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.712l-.36.067-.36-.022-.338-.113-.338-.202-.338-.248-.315-.293-.27-.36-.27-.406-.226-.45-.202-.473-.158-.496-.113-.495-.045-.518-.022-.518.045-.496.112-.518 1.24.406v.202l-.023.248.022.27.023.316.045.338.067.36.045.36.113.383.113.383.157.36.158.36.203.361.202.338.248.315.27.293.316.248z",
    fill: "url(#paint35_linear_1908_844)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.831 8.134l1.289.422v.226l-.023.245.023.268.022.315.045.336.068.361.044.358.224.762.314.718.202.359.202.335.246.313.268.29.313.247-.017.022.005.029-.364.068-.368-.023-.344-.115-.343-.206-.34-.25-.317-.294-.273-.364-.272-.408-.226-.452-.204-.476-.158-.498-.113-.499-.045-.52-.023-.521.046-.499.12-.549zm3.152 5.561l-.267-.21-.274-.296-.25-.319-.202-.338-.204-.363-.317-.724-.226-.768-.045-.362-.068-.36-.045-.34-.022-.315-.023-.273.023-.25v-.18l-1.19-.389-.105.485-.045.492.023.516.045.515.112.493.156.493.202.47.224.449.27.403.267.358.313.29.335.245.334.2.331.111.353.022.295-.055z",
    fill: "#231F20"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.069 8.554l.202.068.248.045.27.112.293.068.27.09.27.09.248.045.18.045.023.316.023.315.022.338.023.338.022.337.045.36.023.339.067.337.068.338.067.316.113.315.113.27.135.293.18.225.18.225.225.203-.27.023h-.27l-.27-.068-.27-.113-.293-.18-.27-.203-.248-.27-.27-.315-.248-.36-.203-.428-.203-.45-.158-.519-.135-.563-.112-.608-.068-.676-.022-.698z",
    fill: "url(#paint36_linear_1908_844)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.039 8.514l.24.08.248.046.271.112.293.068.539.18.248.045.2.05.046.651.068 1.013.045.361.022.336.135.674.067.313.112.313.112.269.133.29.357.445.273.245-.339.029h-.274l-.275-.07-.275-.114-.297-.182-.272-.205-.25-.273-.272-.317-.25-.363-.203-.43-.204-.454-.158-.52-.136-.564-.113-.61-.067-.678-.024-.74zm.06.08l.02.657.068.673.112.607.135.561.157.515.202.449.201.426.246.357.269.314.246.268.267.2.29.178.266.111.265.066h.265l.203-.017-.178-.16-.364-.455-.137-.296-.113-.272-.114-.32-.067-.315-.136-.68-.022-.336-.045-.361-.068-1.014-.043-.61-.16-.04-.248-.045-.541-.18-.294-.068-.27-.112-.247-.045-.165-.055z",
    fill: "#231F20"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.091 14.23l-.585.022-.496-.045-.428-.135-.338-.225-.293-.27-.247-.338-.158-.36-.135-.428-.113-.406-.067-.473-.023-.45-.045-.428-.022-.45-.023-.406-.022-.383-.046-.338.18.023.158.045.158.045.135.045.158.045.135.045.18.045.203.045.045.36.022.338.045.338.046.338.044.315.046.316.067.315.068.293.09.293.112.292.136.27.135.271.18.27.203.27.247.248.248.248z",
    fill: "url(#paint37_linear_1908_844)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.017 9.084l.22.028.318.09.135.046.158.045.134.045.179.044.222.05.047.382.023.337.09.674.09.63.067.314.067.291.09.291.112.29.268.539.18.268.2.268.494.494-.02.02.001.029-.59.022-.498-.045-.434-.138-.343-.228-.297-.274-.251-.343-.16-.366-.136-.429-.113-.409-.068-.475-.022-.45-.045-.429-.023-.45-.022-.405-.023-.382-.05-.374zm3.008 5.12l-.451-.45-.205-.274-.182-.273-.271-.543-.114-.295-.09-.295-.068-.293-.068-.317-.045-.316-.045-.315-.09-.678-.023-.337-.042-.34-.184-.04-.182-.046-.135-.045-.158-.045-.134-.045-.313-.089-.141-.018.04.304.023.382.022.406.023.45.045.428.022.45.067.47.112.403.135.426.156.356.244.333.289.267.333.221.42.133.491.045.519-.02z",
    fill: "#231F20"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.69 14.523l-.518.022-.473-.068-.405-.135-.36-.225-.293-.27-.27-.338-.203-.383-.18-.405-.158-.406-.113-.45-.112-.428-.045-.45-.068-.428-.045-.383-.045-.383-.023-.315.18.045.158.045.135.045.158.022.135.045.135.023.18.045.18.045.068.518.09.473.09.45.09.428.113.36.113.383.135.316.135.293.113.27.157.247.158.226.135.18.158.203.157.135.18.135.158.113z",
    fill: "url(#paint38_linear_1908_844)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.348 9.44l.22.055.158.046.133.044.158.022.135.046.135.022.38.095.07.537.09.471.09.45.09.427.112.36.112.38.134.314.136.294.111.268.156.245.157.224.135.18.156.2.154.133.18.134.157.112-.017.024.002.028-.521.023-.478-.068-.411-.137-.366-.229-.296-.273-.274-.342-.204-.387-.181-.407-.159-.409-.112-.45-.114-.43-.045-.452-.067-.428-.045-.383-.046-.384-.025-.355zm3.258 5.058l-.09-.065-.182-.136-.16-.137-.16-.206-.136-.18-.158-.227-.159-.25-.113-.272-.135-.293-.137-.318-.112-.383-.114-.363-.09-.428-.09-.45-.09-.475-.065-.499-.34-.085-.137-.023-.135-.045-.157-.022-.137-.046-.157-.045-.141-.035.02.275.09.765.067.429.045.448.112.426.112.449.157.403.18.404.2.38.268.334.289.267.355.221.4.134.468.067.432-.02z",
    fill: "#231F20"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.177 14.725l-.496.023-.45-.068-.383-.135-.36-.225-.316-.27-.27-.316-.248-.36-.203-.405-.18-.406-.157-.428-.113-.428-.09-.428-.113-.405-.045-.405-.067-.36-.045-.316.157.045.158.023.158.045.157.045.158.045.158.022.157.045.158.045.022.248.045.27.046.293.09.315.09.338.135.338.135.338.135.338.18.36.18.315.18.316.203.27.203.293.203.225.225.203.203.157z",
    fill: "url(#paint39_linear_1908_844)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.606 9.753l.198.057.16.023.315.09.156.045.16.023.334.095.024.266.045.27.045.291.09.314.089.336.404 1.011.18.359.359.628.202.27.202.291.2.223.223.2.202.158-.017.022.001.029-.498.023-.456-.069-.389-.137-.364-.228-.319-.273-.274-.32-.25-.363-.203-.407-.18-.407-.16-.43-.112-.43-.09-.427-.113-.406-.045-.407-.068-.36-.05-.36zm3.492 4.947l-.143-.11-.228-.206-.205-.228-.202-.292-.204-.273-.361-.632-.181-.362-.407-1.017-.09-.338-.09-.319-.046-.292-.045-.272-.02-.229-.295-.084-.16-.022-.315-.09-.156-.045-.16-.023-.115-.033.039.27.068.363.045.403.112.405.09.427.112.426.157.425.18.405.201.402.246.358.268.313.312.267.355.222.378.133.445.067.415-.019z",
    fill: "#231F20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.82 15.018l-.517.068-.473-.068-.428-.157-.383-.27-.383-.338-.315-.383-.27-.45-.27-.451-.203-.496-.203-.473-.158-.45-.112-.428-.09-.36-.068-.316-.045-.203v-.135l.203.023.18.045.18.067.203.023.18.068.157.022.18.045.158.023.068.225.067.27.09.293.09.338.113.36.113.36.135.383.135.383.158.36.18.338.18.338.203.27.203.248.225.203.247.158.27.067z",
    fill: "url(#paint40_linear_1908_844)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.014 14.95l-.473.113h-.405l-.383-.09-.36-.18-.316-.248-.27-.315-.248-.36-.225-.406-.18-.405-.18-.428-.113-.45-.135-.406-.113-.405-.067-.36-.09-.316-.068-.248.158.045h.135l.135.023.113.022.135.045.113.023.112.022.113.023.045.293.067.315.068.315.09.293.09.315.135.316.113.292.157.27.158.293.203.27.203.27.202.226.248.248.248.203.293.202.292.18z",
    fill: "url(#paint41_linear_1908_844)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.347 10.405l.203.057h.133l.139.024.116.023.133.044.111.023.245.049.048.311.067.315.068.314.09.292.09.314.134.314.112.29.157.27.156.29.404.539.201.223.246.247.246.2.291.202.292.18-.015.024.007.028-.476.114h-.412l-.39-.092-.365-.183-.32-.251-.274-.32-.25-.363-.226-.407-.18-.406-.181-.43-.113-.452-.135-.405-.114-.408-.067-.36-.09-.314-.08-.296zm3.594 4.534l-.236-.145-.294-.204-.25-.205-.249-.249-.204-.227-.407-.542-.158-.294-.159-.272-.113-.295-.136-.318-.09-.315-.091-.295-.067-.315-.068-.317-.042-.273-.093-.019-.23-.046-.132-.044-.11-.022-.133-.022h-.137l-.113-.033.055.199.09.318.067.359.113.403.135.407.112.449.18.425.179.404.224.403.246.358.267.312.311.245.355.177.376.088h.4l.402-.095z",
    fill: "#231F20"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.524 15.198h-.406l-.383-.045-.36-.09-.36-.135-.316-.18-.338-.225-.292-.27-.293-.293-.248-.316-.225-.36-.225-.383-.18-.405-.158-.45-.135-.451-.113-.473-.09-.473.18.022.158.023.18.045.18.022.158.046.158.022.18.023.157.045.09.27.046.293.09.27.067.293.068.27.09.27.113.27.112.27.135.271.158.27.203.27.225.248.27.248.315.27.36.27.429.248z",
    fill: "url(#paint42_linear_1908_844)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.366 10.616l.22.027.16.023.18.045.18.022.158.046.155.022.182.023.175.05.095.286.045.293.09.27.068.293.067.27.09.267.224.539.134.269.157.268.2.268.224.245.269.247.314.27.358.268.427.247-.015.024v.03h-.408l-.387-.047-.363-.09-.363-.137-.319-.182-.34-.227-.295-.272-.295-.296-.25-.317-.225-.361-.227-.386-.18-.408-.159-.451-.135-.452-.113-.475-.098-.511zm4.051 4.554l-.339-.196-.361-.272-.316-.27-.273-.25-.227-.25-.204-.273-.159-.272-.136-.272-.226-.543-.09-.272-.068-.27-.067-.292-.09-.271-.046-.293-.084-.254-.141-.04-.179-.023-.161-.023-.156-.044-.181-.023-.179-.045-.156-.022-.14-.018.082.434.112.472.135.449.157.448.18.403.223.381.224.359.246.313.291.29.291.27.335.223.313.178.356.134.357.09.38.044h.297z",
    fill: "#231F20"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.64 15.446l-.517.023-.496-.023-.45-.067-.45-.136-.406-.18-.383-.225-.338-.248-.315-.315-.293-.338-.27-.36-.226-.406-.202-.405-.18-.45-.136-.45-.112-.474-.068-.473.136.023.157.045.158.022.157.023.158.022.18.045.158.023.18.045.045.315.09.338.09.315.136.316.157.315.18.315.203.316.203.292.247.27.27.271.271.248.293.247.315.203.338.203.36.158.36.157z",
    fill: "url(#paint43_linear_1908_844)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.764 10.884l.177.03.156.044.474.068.179.045.159.023.199.05.047.332.09.336.09.314.133.312.157.314.18.314.202.314.201.291.246.269.27.269.269.247.29.246.314.202.336.201.719.315-.012.026.002.029-.52.022-.5-.023-.452-.068-.456-.136-.408-.182-.385-.227-.34-.25-.318-.318-.294-.339-.273-.363-.225-.407-.204-.408-.18-.453-.136-.452-.114-.475-.073-.512zm4.752 4.539l-.611-.268-.338-.203-.319-.205-.294-.248-.27-.25-.272-.27-.25-.273-.203-.294-.204-.317-.18-.316-.159-.317-.137-.319-.09-.316-.09-.341-.043-.296-.16-.04-.159-.023-.178-.045-.314-.045-.162-.023-.156-.045-.095-.015.062.432.112.471.135.449.179.448.202.404.224.403.268.358.292.336.313.313.335.246.38.223.402.18.447.133.447.067.492.023.394-.017z",
    fill: "#231F20"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M32.812 15.558l-.45-.022-.406-.068-.428-.09-.405-.158-.383-.202-.383-.203-.338-.248-.338-.292-.293-.316-.293-.338-.247-.383-.225-.382-.18-.406-.158-.405-.135-.428-.068-.45.135.022h.135l.113.022.135.023h.113l.135.023.157.045.18.022.18.383.159.338.157.338.135.315.158.315.158.27.157.27.158.249.203.247.202.226.226.225.27.225.293.203.36.225.36.203.45.202z",
    fill: "url(#paint44_linear_1908_844)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.906 15.694l-.653.022-.586-.022-.54-.09-.495-.136-.474-.202-.405-.248-.383-.27-.338-.316-.315-.338-.293-.36-.247-.383-.226-.405-.225-.405-.203-.406-.18-.428-.18-.405.113.022.157.023.203.022.203.023.203.045.18.022.157.023.135.023.158.36.158.36.202.36.203.316.225.315.226.293.247.27.27.27.293.248.293.248.316.225.337.225.338.18.36.203.36.158.406.158z",
    fill: "url(#paint45_linear_1908_844)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.114 11.263l.166.033.157.023.408.045.201.045.18.022.158.023.15.025.164.375.157.359.202.358.202.314.224.314.224.292.247.269.269.269.584.494.314.224.336.224.337.18.36.202.358.157.405.157-.01.027v.028l-.655.023-.59-.023-.543-.09-.499-.137-.475-.204-.408-.25-.386-.272-.34-.317-.316-.34-.295-.362-.248-.384-.451-.812-.204-.408-.18-.427-.203-.456zm5.652 4.407l-.277-.107-.363-.16-.36-.202-.34-.181-.338-.226-.317-.227-.588-.497-.27-.271-.25-.272-.226-.294-.226-.316-.203-.317-.205-.363-.309-.707-.12-.02-.156-.022-.183-.023-.2-.045-.406-.045-.159-.022-.058-.012.158.355.18.427.201.404.45.81.247.38.29.359.315.336.335.314.38.268.404.247.469.2.492.135.537.09.583.022.513-.018z",
    fill: "#231F20"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M36.145 15.874h-.338l-.383-.068-.383-.09-.405-.135-.405-.18-.406-.203-.428-.248-.405-.27-.383-.315-.383-.338-.36-.36-.338-.406-.293-.405-.27-.428-.248-.45-.203-.473.203.022.203.023.202.022.203.023h.18l.158.045.135.022.068.045.248.18.225.18.248.248.247.226.248.27.27.27.27.293.248.293.27.293.27.292.294.293.27.293.293.27.292.27.293.27.293.226z",
    fill: "url(#paint46_linear_1908_844)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.469 11.471l.454.05.404.045h.182l.16.046.14.024.073.049.25.18.227.183.247.247.25.227.247.27.27.27.271.294.248.292.54.585.292.293.27.292.877.81.291.224-.017.022v.029h-.34l-.387-.068-.386-.091-.408-.136-.406-.181-.407-.204-.43-.248-.407-.272-.384-.316-.384-.34-.362-.361-.34-.407-.293-.407-.271-.43-.25-.453-.221-.518zm5.592 4.375l-.228-.176-.88-.812-.27-.293-.293-.293-.542-.586-.247-.293-.27-.292-.27-.27-.247-.27-.248-.225-.246-.247-.224-.178-.247-.18-.062-.041-.132-.022-.154-.044h-.179l-.608-.068-.154-.017.183.427.247.448.269.426.291.404.337.404.359.359.381.337.382.314.403.269.427.247.404.202.403.179.403.134.381.09.38.067h.25z",
    fill: "#231F20"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M38.06 15.874l-.339.225-.36.09h-.338l-.383-.09-.36-.18-.36-.248-.383-.315-.383-.36-.383-.406-.383-.405-.428-.45-.405-.451-.406-.428-.405-.428-.428-.405-.428-.36h.158l.157.044h.203l.203.045.203.023.225.045.18.022.18.046.316.292.337.293.316.316.315.315.293.315.315.315.293.316.293.292.292.293.293.27.27.226.27.203.271.18.27.157.27.135.248.068z",
    fill: "url(#paint47_linear_1908_844)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.81 11.634h.24l.158.045h.202l.204.045.204.023.224.045.182.023.188.047.32.297.339.294.631.631.293.315.315.316.293.315.584.585.292.27.27.223.268.202.27.18.268.156.267.134.245.067-.008.027.016.024-.342.228-.368.092h-.345l-.39-.092-.366-.183-.362-.25-.385-.316-.384-.362-.765-.81-.429-.451-.405-.45-.81-.856-.427-.404-.487-.41zm6.181 4.251l-.19-.052-.274-.137-.272-.159-.271-.18-.272-.204-.271-.226-.294-.271-.586-.587-.292-.315-.316-.315-.292-.315-.63-.63-.338-.293-.31-.287-.171-.043-.18-.023-.224-.045-.205-.022-.2-.045H32.2l-.158-.045h-.075l.37.31.428.407.811.857.405.45.428.45.765.81.382.36.381.313.358.246.355.178.377.089h.33l.353-.088.281-.188z",
    fill: "#231F20"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.546 16.054h-.54l-.496-.067-.473-.113-.45-.18-.406-.203-.383-.27-.36-.293-.338-.315-.338-.338-.337-.36-.316-.338-.315-.383-.338-.36-.338-.36-.36-.316-.36-.316h.135l.157.023.18.023.203.022.203.023h.157l.136.022h.067l.225.045.226.113.225.135.225.203.248.247.248.27.27.293.248.316.315.315.293.338.337.338.36.315.384.338.405.293.428.292.473.248z",
    fill: "url(#paint48_linear_1908_844)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.321 11.814h.213l.16.023.18.022.202.023.201.022h.159l.135.023h.068l.231.046.231.115.228.137.228.205.249.25.247.27.272.294.247.314.315.315.292.337.337.337.36.314.381.337.404.292.426.292.472.247-.013.025v.029H39l-.498-.068-.475-.114-.454-.181-.408-.204-.386-.273-.362-.294-.338-.316-.339-.338-.338-.36-.316-.34-.315-.382-.674-.72-.777-.679zm6.108 4.212l-.373-.196-.428-.293-.408-.295-.382-.337-.362-.317-.34-.34-.291-.336-.317-.317-.247-.315-.27-.292-.247-.27-.247-.247-.223-.2-.221-.133-.221-.11-.219-.044h-.067l-.135-.023h-.159l-.202-.022-.203-.023-.181-.023-.156-.022h-.057l.303.265.363.318.677.722.314.382.315.337.338.36.337.337.337.314.358.292.38.269.403.2.447.18.47.112.492.067h.422z",
    fill: "#231F20"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M10.357 5.244v-.045l-.023-.158v-.225l-.022-.27-.023-.316.023-.36.022-.36.023-.383.09-.36.09-.339.135-.315.203-.248.225-.18.293-.09.338-.022.405.112-.112.113-.136.157-.112.203-.113.203-.09.248-.09.225-.09.27-.09.27-.09.27-.068.27-.067.271-.068.27-.045.27-.045.248-.045.226-.045.202h-.068l-.045-.022-.067-.023-.045-.022-.045-.023-.068-.022-.068-.023-.067-.022z",
    fill: "url(#paint49_linear_1908_844)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.83 5.446l.18-.856.18-.72.18-.609.18-.518.181-.405.203-.338.18-.225.157-.18.18-.113.158-.045.18-.022.136.022.157.045.135.068.113.09.113.067-.203.18-.18.203-.158.18-.157.203-.158.203-.135.225-.136.225-.112.248-.113.248-.112.247-.113.27-.09.271-.068.293-.09.293-.067.292-.068.316-.157-.023h-.113l-.09-.045-.045-.022h-.068l-.045-.023-.045-.022-.09-.023z",
    fill: "url(#paint50_linear_1908_844)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.79 1.386l.143.024.16.046.14.07.113.09.145.087-.23.205-.18.201-.157.18-.314.403-.268.448-.337.741-.112.27-.09.267-.067.294-.09.291-.067.292-.074.341-.182-.026h-.117l-.135-.067h-.068l-.093-.047-.087-.022.007-.028-.028-.006.18-.856.18-.722.181-.61.181-.52.182-.409.205-.34.181-.227.16-.183.188-.117.164-.047.186-.023zm-1.926 4.04l.066.016.087.043h.068l.135.068h.107l.134.019.062-.29.068-.295.09-.291.068-.295.09-.272.114-.271.339-.746.272-.454.316-.406.158-.18.183-.206.174-.154-.083-.05-.11-.088-.13-.065-.154-.044-.13-.021-.173.022-.152.043-.173.108-.154.177-.179.223-.2.335-.18.402-.18.516-.18.607-.179.72-.174.828z",
    fill: "#231F20"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M11.483 5.694l.045-.316.068-.36.112-.383.136-.428L12 3.78l.203-.428.203-.405.247-.383.248-.338.248-.292.293-.226.27-.135.315-.045.293.045.293.158.292.315-.225.158-.225.202-.203.203-.202.203-.203.203-.158.225-.157.248-.158.225-.135.27-.113.27-.135.27-.09.293-.09.293-.068.315-.067.338-.045.338-.135-.045-.158-.045-.18-.068L12 5.896l-.157-.067-.158-.068-.113-.045-.09-.022z",
    fill: "url(#paint51_linear_1908_844)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.028 1.499l.302.046.302.162.318.343-.25.176-.224.2-.606.607-.156.222-.158.249-.156.223-.134.268-.113.27-.134.269-.18.582-.067.314-.067.337-.05.37-.167-.055-.16-.046-.178-.067-.16-.045-.315-.136-.11-.044-.089-.022.007-.028-.028-.004.045-.316.068-.363.113-.384.136-.43.158-.43.203-.428.204-.408.25-.384.248-.34.25-.295.297-.228.277-.139.324-.046zm-2.513 4.174l.069.017.113.046.314.134.158.045.179.067.158.045.102.035.04-.306.068-.338.069-.318.18-.588.136-.271.113-.271.136-.272.159-.227.158-.248.159-.227.61-.611.229-.205.198-.139-.267-.288-.284-.153-.284-.043-.306.043-.264.132-.288.222-.245.29-.247.336-.247.38-.201.405-.202.426-.157.426-.135.427-.112.381-.068.359-.04.289z",
    fill: "#231F20"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16.618 2.248l-.315-.203-.315-.112-.338-.045-.315.045-.338.09-.316.18-.292.225-.293.293-.248.315-.27.36-.225.406-.203.428-.158.428-.135.473-.112.473-.045.495.157.045.158.023.157.067.158.046.18.067.158.045.158.045.18.023.112-.293.113-.338.113-.315.135-.338.112-.338.158-.338.135-.338.158-.315.157-.293.158-.27.18-.27.203-.225.203-.203.202-.158.226-.112.247-.068z",
    fill: "url(#paint52_linear_1908_844)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.65 1.859l.344.046.322.115.318.204-.016.024.008.028-.245.067-.22.11-.2.154-.2.201-.201.223-.179.268-.157.27-.157.291-.157.314-.135.338-.157.337-.113.338-.135.337-.112.314-.113.34-.12.313-.205-.026-.32-.091-.179-.067-.16-.046-.154-.066-.158-.023-.18-.052.047-.52.114-.477.135-.475.159-.43.203-.43.228-.409.27-.36.25-.318.296-.296.296-.227.319-.182.344-.092.32-.045zm.899.378l-.259-.166-.31-.11-.33-.044-.31.044-.332.089-.31.177-.29.223-.29.29-.247.314-.27.358-.223.403-.202.426-.157.426-.134.471-.112.47-.043.47.133.038.16.023.159.069.158.045.18.067.311.09.156.019.104-.272.113-.337.113-.317.135-.337.113-.34.158-.337.135-.34.158-.315.159-.294.158-.272.181-.272.206-.228.205-.205.205-.159.23-.115.189-.052z",
    fill: "#231F20"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 2.63l-.518-.202-.428-.135h-.406l-.36.068-.315.135-.27.225-.248.27-.226.338-.18.36-.18.406-.18.428-.158.428-.135.428-.157.427-.158.406-.158.383.135.022.135.023.136.045.112.045.135.045.135.045.158.045.135.022.023-.045v-.135l.045-.157.045-.248.045-.27.113-.316.09-.337.157-.36.158-.361.203-.338.247-.36.27-.338.338-.316.36-.247.429-.248.473-.18z",
    fill: "url(#paint53_linear_1908_844)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.706 2.264h.412l.434.137.518.203-.01.027.01.027-.47.179-.426.246-.357.246-.335.312-.269.336-.246.358-.202.336-.313.717-.09.338-.112.313-.045.268-.046.25-.044.154v.138l-.035.07-.159-.026-.159-.046-.271-.09-.112-.045-.132-.044-.304-.05.171-.417.158-.405.157-.427.136-.428.158-.43.18-.428.18-.406.182-.364.227-.34.252-.274.274-.228.322-.138.366-.069zm1.274.366l-.448-.175-.423-.133h-.398l-.355.066-.308.132-.266.222-.245.267-.223.334-.179.359-.18.404-.18.427-.157.427-.135.428-.158.429-.158.406-.144.35.237.039.14.046.111.045.269.09.155.044.113.019.01-.02v-.133l.046-.16.045-.246.045-.273.113-.316.09-.339.318-.726.204-.34.249-.361.272-.34.34-.318.364-.25.43-.249.406-.155z",
    fill: "#231F20"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M19.906 2.924l-.292-.225-.338-.158-.383-.045-.36.023-.383.067-.406.158-.383.225-.383.248-.36.338-.338.36-.293.428-.292.45-.226.496-.18.518-.112.54-.068.586 1.351.338.068-.225.113-.248.09-.293.135-.293.157-.315.158-.338.18-.315.203-.338.225-.315.248-.316.27-.292.27-.27.293-.248.338-.226.338-.18.36-.135z",
    fill: "url(#paint54_linear_1908_844)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.894 2.467l.39.046.345.161.336.259-.407.152-.335.179-.335.223-.291.246-.269.27-.27.29-.246.315-.224.314-.202.336-.18.314-.157.338-.157.315-.134.29-.091.295-.112.246-.075.25-1.402-.351.07-.614.114-.544.181-.52.227-.498.294-.452.294-.43.34-.363.363-.34.386-.25.385-.226.41-.16.389-.068.363-.023zm-.358.08l-.379.067-.4.156-.38.223-.38.246-.359.336-.335.358-.292.426-.291.448-.224.492-.179.515-.112.538-.065.56 1.301.324.06-.202.113-.246.09-.295.136-.294.158-.315.158-.34.18-.315.205-.34.226-.316.249-.317.271-.294.272-.272.295-.25.34-.226.342-.182.312-.117-.25-.192-.33-.154-.376-.044-.356.022z",
    fill: "#231F20"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16.438 7.315l.203.045.247.046.248.067.27.09.27.09.248.068.226.067.225.068-.045-.023.18-.315.158-.338.135-.338.135-.36.158-.36.135-.316.135-.36.18-.36.18-.316.18-.27.226-.293.225-.247.203-.226.27-.18.27-.135.27-.113-.247-.157-.248-.113-.27-.09-.316-.022-.315.022-.315.09-.338.135-.338.203-.338.248-.338.315-.337.383-.338.45-.316.518-.315.586-.293.698-.27.743z",
    fill: "url(#paint55_linear_1908_844)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.29 2.895l.32.023.277.092.25.114.295.188-.32.133-.267.134-.266.178-.2.222-.225.247-.224.291-.18.269-.178.314-.18.358-.135.36-.135.315-.157.36-.135.36-.136.34-.159.34-.165.289.018.009-.021.053-.45-.135-.25-.068-.539-.18-.246-.067-.247-.045-.203-.045.006-.028-.027-.01.271-.745.294-.7.316-.587.317-.52.34-.453.339-.385.34-.317.34-.25.34-.203.343-.137.318-.09.32-.024zm-3.814 4.4l.17.038.25.045.25.068.54.18.247.068.38.114.172-.303.157-.336.134-.337.136-.361.158-.36.134-.315.136-.362.181-.362.182-.317.181-.272.227-.295.225-.247.205-.228.276-.184.272-.136.22-.091-.2-.128-.244-.11-.266-.09-.31-.021-.31.022-.31.089-.335.133-.335.201-.335.246-.336.313-.336.381-.336.449-.314.516-.315.584-.292.696-.259.712z",
    fill: "#231F20"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.015 3.87l-.541-.293-.473-.158-.45-.045-.406.068-.36.157-.338.226-.293.315-.27.36-.225.406-.226.428-.202.473-.18.45-.18.45-.18.428-.158.406-.158.338.18.045.158.022.157.045.136.023.157.045.158.045.158.022.202.046.18-.36.158-.361.158-.338.157-.338.136-.315.18-.293.18-.315.158-.27.202-.27.203-.249.203-.247.247-.226.27-.202.271-.18.315-.18.316-.158z",
    fill: "url(#paint56_linear_1908_844)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.55 3.345l.457.046.478.16.543.293-.013.025.012.026-.314.157-.314.18-.269.179-.268.201-.245.223-.404.493-.201.269-.157.268-.18.317-.18.29-.135.315-.315.675-.158.362-.19.38-.223-.05-.16-.023-.315-.09-.136-.022-.156-.045-.159-.023-.213-.053.171-.369.158-.405.18-.428.36-.901.204-.475.226-.429.227-.408.272-.363.295-.318.343-.228.366-.16.413-.069zm1.403.523l-.49-.265-.468-.156-.443-.044-.398.066-.355.155-.333.222-.29.312-.268.358-.224.403-.225.427-.202.471-.36.901-.18.428-.158.407-.143.306.145.036.16.023.156.045.137.023.313.09.158.022.18.04.17-.34.158-.36.315-.675.136-.317.181-.294.18-.315.16-.273.203-.271.407-.498.251-.228.272-.204.272-.18.316-.182.267-.133z",
    fill: "#231F20"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24.659 4.342l-.496-.27-.45-.112-.45-.045-.406.067-.383.158-.36.248-.338.292-.316.338-.292.383-.27.405-.27.428-.204.428-.225.45-.18.384-.157.382-.136.316.18.045.18.045.158.045.136.022.157.045.158.023.203.023.202.045.225-.518.248-.496.225-.428.226-.428.202-.36.203-.315.203-.293.202-.293.203-.203.203-.202.225-.18.225-.136.203-.112.248-.09.247-.045.27-.046z",
    fill: "url(#paint57_linear_1908_844)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.261 3.886l.457.045.456.114.498.272-.013.026.004.028-.27.045-.245.044-.243.089-.2.111-.224.134-.222.178-.403.402-.403.583-.202.315-.202.359-.45.855-.248.495-.234.539-.224-.05-.202-.023-.162-.023-.156-.045-.137-.022-.157-.045-.392-.099.148-.345.158-.385.18-.383.226-.45.204-.431.27-.428.272-.407.294-.385.318-.34.34-.295.363-.25.389-.16.412-.068zm1.311.442l-.42-.229-.444-.111-.445-.045-.398.067-.377.155-.357.245-.335.291-.314.336-.291.38-.27.405-.269.426-.202.427-.225.45-.18.382-.157.383-.122.284.329.082.156.045.136.023.156.044.155.023.206.022.18.04.216-.497.248-.496.45-.857.204-.362.203-.316.407-.587.41-.41.228-.182.226-.136.205-.113.252-.092.25-.046.19-.031z",
    fill: "#231F20"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 4.703l-.473-.225-.428-.113h-.428l-.405.09-.36.158-.361.225-.338.27-.315.338-.27.36-.248.406-.27.405-.203.406-.203.405-.18.383-.158.36-.135.338.158.045.135.023.157.022.136.045.135.023.135.023.158.045.18.022.067-.248.136-.292.135-.293.18-.316.18-.315.225-.315.225-.316.248-.315.248-.293.27-.292.293-.248.27-.225.293-.203.27-.18.27-.135.27-.068z",
    fill: "url(#paint58_linear_1908_844)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.543 4.337h.435l.434.114.475.226-.012.026.007.028-.267.067-.266.133-.269.179-.291.201-.27.225-.29.246-.27.291-.246.292-.248.315-.449.629-.359.628-.268.582-.074.27-.207-.026-.158-.046-.271-.045-.135-.045-.156-.022-.138-.023-.188-.054.147-.368.158-.361.18-.384.408-.813.27-.405.249-.408.272-.362.317-.34.342-.273.362-.226.365-.16.411-.091zm1.248.358l-.399-.19-.421-.111h-.422l-.4.089-.355.155-.357.224-.335.268-.313.335-.269.358-.247.405-.27.404-.404.809-.18.382-.157.36-.123.308.125.035.134.023.16.023.135.045.271.045.156.044.153.02.062-.226.272-.59.362-.634.451-.631.248-.316.25-.294.272-.295.293-.248.272-.227.293-.203.274-.182.273-.136.196-.05z",
    fill: "#231F20"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M27.361 5.086l-.473-.27-.473-.113h-.473l-.45.135-.428.203-.428.315-.383.36-.383.383-.337.428-.293.428-.27.428-.226.405-.18.338-.157.316-.068.225-.045.135.203.022.157.045.18.046.158.045.18.022.158.023.18.045.158.022.112-.225.136-.27.157-.316.18-.315.203-.36.203-.338.225-.338.248-.36.247-.338.248-.293.293-.27.27-.225.293-.18.27-.136.316-.045.292.023z",
    fill: "url(#paint59_linear_1908_844)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.938 4.674h.48l.481.115.477.272-.015.025-.002.028-.29-.022-.307.044-.265.132-.29.179-.268.223-.291.269-.246.29-.247.337-.247.36-.225.337-.202.337-.203.36-.18.315-.414.828-.18-.025-.18-.045-.155-.022-.183-.023-.159-.046-.18-.045-.156-.044-.235-.027.056-.168.068-.227.159-.318.18-.338.226-.407.271-.429.294-.43.34-.43.384-.383.385-.363.43-.317.433-.205.456-.137zm1.299.374l-.36-.206-.465-.11h-.465l-.445.133-.423.2-.424.313-.382.359-.381.381-.336.426-.292.427-.27.427-.224.404-.18.337-.157.313-.067.224-.034.101.17.02.16.045.18.045.156.045.178.022.16.023.18.045.135.019.397-.794.18-.315.203-.361.204-.339.225-.338.249-.361.249-.34.25-.295.294-.271.271-.227.297-.182.275-.137.323-.046.169.013z",
    fill: "#231F20"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28.442 5.491l-.427-.293-.428-.157-.383-.023-.406.068-.36.157-.36.226-.316.292-.315.36-.293.384-.27.405-.248.405-.247.428-.203.383-.18.383-.136.315-.135.248.158.023.135.045.113.045.112.045.113.022.113.045.09.023.135.022.112-.315.136-.338.157-.315.158-.315.18-.316.18-.27.203-.293.225-.27.248-.27.248-.248.27-.203.293-.202.315-.158.315-.158.338-.09.36-.09z",
    fill: "url(#paint60_linear_1908_844)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.202 4.99l.39.023.436.16.43.295-.016.023.007.028-.36.09-.335.09-.626.313-.29.2-.269.202-.245.246-.247.27-.224.268-.202.291-.18.27-.179.313-.314.63-.135.336-.12.337-.161-.027-.094-.023-.11-.045-.113-.022-.227-.091-.132-.044-.196-.028.155-.283.135-.315.18-.384.204-.384.248-.428.248-.407.271-.406.294-.385.318-.362.317-.295.365-.228.365-.16.412-.068zm1.172.49L28 5.223l-.42-.155-.376-.022-.398.067-.356.155-.356.223-.312.29-.314.358-.292.382-.269.404-.247.404-.248.428-.202.381-.18.382-.135.317-.116.212.12.017.139.046.223.09.112.022.113.045.087.022.11.019.106-.294.136-.34.316-.632.181-.317.18-.27.205-.296.226-.271.249-.271.249-.25.273-.204.294-.204.635-.317.341-.091.299-.075z",
    fill: "#231F20"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M29.816 5.806l-.383-.135-.383-.09-.405-.045-.36.045-.383.068-.36.112-.339.203-.36.203-.338.27-.315.315-.293.338-.293.383-.27.428-.225.45-.248.496-.203.495.18.045.18.023.159.045.18.045.157.045.18.045.158.045.18.023.113-.293.113-.293.135-.293.112-.315.135-.27.158-.293.158-.27.18-.27.225-.248.248-.248.27-.225.293-.225.36-.18.36-.158.451-.158.473-.113z",
    fill: "url(#paint61_linear_1908_844)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.645 5.508l.412.045.386.091.383.136-.01.027.007.027-.471.113-.448.157-.36.156-.356.18-.29.222-.27.224-.246.247-.223.245-.179.268-.157.27-.157.291-.134.269-.113.316-.135.292-.233.605-.204-.025-.16-.046-.18-.045-.157-.045-.181-.045-.155-.045-.182-.022-.212-.054.216-.528.474-.948.272-.43.294-.384.294-.34.318-.317.34-.272.361-.203.34-.205.368-.114.384-.068.364-.045zm1.07.293l-.29-.102-.38-.09-.4-.044-.356.045-.38.067-.355.11-.336.202-.358.202-.335.268-.314.313-.291.336-.292.382-.268.425-.472.944-.19.464.146.037.18.022.16.046.18.045.158.045.18.045.156.044.156.02.218-.567.135-.291.113-.318.136-.27.158-.294.158-.272.182-.272.227-.25.25-.25.271-.226.295-.227.364-.182.363-.158.453-.159.378-.09z",
    fill: "#231F20"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M31.753 6.257l-.495-.203-.496-.135-.473-.068h-.45l-.428.068-.428.113-.406.18-.36.202-.36.293-.338.315-.293.338-.293.406-.27.428-.203.473-.225.473-.18.495.158.023.157.045.18.022.18.023.18.022.181.023.18.022.18.045.113-.383.113-.337.157-.338.18-.338.203-.293.225-.293.226-.27.27-.248.27-.247.315-.18.338-.203.338-.158.36-.113.383-.112.406-.045.405-.045z",
    fill: "url(#paint62_linear_1908_844)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.837 5.823h.454l.479.068.499.136.495.203-.01.027.002.028-.808.09-.38.112-.359.112-.334.156-.337.202-.313.179-.537.492-.223.268-.225.292-.201.29-.18.337-.156.335-.112.336-.12.409-.205-.052-.901-.112-.158-.045-.19-.028.192-.53.225-.473.204-.475.272-.431.294-.407.295-.34.34-.317.362-.294.365-.206.407-.18.433-.114.43-.068zm1.801.418l-.39-.16-.492-.134-.469-.067h-.446l-.424.067-.425.112-.402.178-.357.201-.357.29-.336.314-.291.336-.292.404-.268.425-.203.472-.224.472-.168.46.127.019.155.045.902.112.154.039.105-.358.114-.34.158-.34.182-.34.204-.294.225-.294.228-.273.543-.498.318-.181.34-.204.341-.16.361-.112.386-.113.701-.078z",
    fill: "#231F20"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7 6.37l-.429-.068-.45-.045-.428.022-.428.045-.405.113-.406.135-.383.158-.36.225-.338.248-.338.293-.27.315-.293.338-.225.405-.203.428-.18.45-.135.473.158.023.135.022.135.023.135.023.135.022.113.023.157.045.18.022.226-.383.203-.36.18-.338.18-.315.18-.293.18-.27.158-.27.203-.226.202-.225.248-.203.248-.18.293-.18.337-.135.383-.135.428-.113.473-.113z",
    fill: "url(#paint63_linear_1908_844)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.821 6.228l.455.046.427.067-.004.029.007.027-.473.113-.426.112-.382.135-.335.134-.29.178-.246.18-.245.2-.402.447-.157.269-.18.27-.18.291-.18.315-.18.338-.203.36-.234.4-.201-.025-.16-.046-.11-.022-.54-.09-.19-.027.145-.507.181-.452.204-.43.226-.408.295-.34.272-.317.341-.295.34-.25.362-.226.387-.159.407-.135.407-.114.432-.045.43-.023zm.73.147l-.284-.045-.447-.044-.425.022-.425.045-.402.111-.404.135-.38.156-.357.224-.336.246-.335.29-.27.315-.29.335-.224.402-.202.427-.179.448-.126.44.126.018.542.09.114.023.156.045.16.02.215-.367.202-.36.18-.338.181-.316.181-.294.18-.27.158-.271.41-.455.25-.205.25-.181.294-.182.342-.136.385-.136.428-.113.333-.079z",
    fill: "#231F20"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M34.794 6.64l-.653-.158-.631-.09-.563-.022-.518.045-.473.113-.45.157-.406.203-.383.248-.338.292-.315.338-.293.36-.27.383-.248.383-.247.428-.203.406-.203.428.09.022.158.023.158.022.157.045.18.023.158.045.135.022h.113l.202-.383.203-.36.248-.338.248-.315.27-.315.27-.27.293-.248.315-.226.338-.225.338-.18.36-.18.36-.18.383-.136.383-.135.406-.112.428-.113z",
    fill: "url(#paint64_linear_1908_844)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M36.032 6.775l-.36-.067-.383-.023-.428.023-.428.067-.428.09-.45.135-.45.18-.428.203-.45.248-.429.293-.405.315-.383.36-.36.383-.338.428-.27.45-.248.496.18.023.18.022.18.045.18.023.158.045.135.045h.18l.248-.158.27-.18.27-.225.293-.225.293-.248.293-.27.315-.27.316-.27.338-.271.315-.27.338-.27.337-.271.36-.248.339-.225.383-.203.337-.18z",
    fill: "url(#paint65_linear_1908_844)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M37.79 7.27l-.339-.337-.36-.18-.36-.09-.383.022-.383.112-.428.203-.405.27-.451.293-.45.36-.45.383-.474.406-.45.405-.473.406-.473.383-.473.36-.473.315.135.023.18.022h.203l.225.023.203.022h.428l.18-.022.338-.248.36-.27.338-.293.315-.27.316-.293.292-.27.293-.27.315-.27.316-.226.292-.225.316-.203.338-.18.337-.135.36-.113.361-.067.383-.046z",
    fill: "url(#paint66_linear_1908_844)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M39.096 7.428l-.541-.135-.518-.045-.496.022-.45.09-.428.158-.428.203-.405.248-.383.27-.383.315-.383.315-.383.338-.36.36-.383.316-.383.338-.405.27-.406.293h.136l.157.022.203.045h.203l.18.023.18.045h.135l.068.022h.247l.226-.067.247-.135.27-.158.27-.203.271-.247.315-.293.316-.293.315-.293.36-.315.383-.293.383-.293.45-.27.428-.27.474-.203.517-.18z",
    fill: "url(#paint67_linear_1908_844)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.04 7.22l.52.045.542.135-.007.028.01.027-.517.18-.47.201-.427.27-.449.27-.764.583-.359.315-.946.878-.272.25-.273.204-.271.158-.25.137-.233.07h-.256l-.068-.023h-.134l-.182-.046-.176-.022h-.205l-.204-.045-.155-.022h-.221l.478-.346.404-.269.382-.337.382-.314.36-.361.384-.339.767-.631.385-.272.408-.249.43-.204.43-.158.455-.091.501-.023zm.955.213l-.445-.112-.514-.044-.491.022-.446.09-.425.156-.425.201-.404.247-.38.269-.766.63-.381.336-.362.362-.383.315-.385.34-.405.27-.333.24h.048l.162.023.2.045h.203l.183.023.177.044h.136l.068.023h.239l.218-.066.245-.133.268-.157.268-.2.27-.247.946-.88.362-.316.768-.587.45-.27.43-.271.477-.205.427-.148z",
    fill: "#231F20"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M40.74 7.879l-.473-.27-.518-.113h-.496l-.518.112-.495.18-.518.293-.496.316-.495.36-.45.383-.451.405-.428.36-.406.339-.337.292-.338.226-.293.135-.248.045.225.022.203.045.27.023.248.045.27.022.248.046.27.022h.203l.383-.27.315-.27.316-.248.27-.27.27-.248.248-.248.27-.225.248-.226.248-.202.27-.203.293-.18.315-.18.338-.158.36-.135.428-.113.45-.112z",
    fill: "url(#paint68_linear_1908_844)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M40.754 7.854l-.015.025.007.028-.45.112-.426.113-.358.134-.336.156-.314.18-.291.18-.269.2-.247.202-.248.226-.269.224-.248.248-.27.247-.272.273-.315.247-.317.272-.39.275h-.214l-.273-.023-.246-.045-.272-.023-.246-.045-.273-.022-.201-.045-.224-.023-.002-.056.244-.044.288-.133.334-.223.337-.292.405-.338.428-.36.45-.406.453-.384.497-.361.496-.316.52-.294.502-.182.52-.113h.502l.526.114.477.272z",
    fill: "#231F20"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96 2.496l-.044-.113-.068-.157-.045-.135-.045-.158-.045-.158-.023-.157-.022-.158-.023-.18-.022-.158V.627l.022-.158.023-.158.045-.157.045-.135-.225.27-.158.293-.113.292-.067.316-.023.315v.315l.045.316.068.315.068.293.112.315.113.293.112.315.136.27.112.293.135.27.113.27-.023-.067-.022-.09V4.41l-.023-.157v-.45l-.022-.18v-.361l-.023-.158v-.158l-.045-.157-.022-.158-.045-.135z",
    fill: "url(#paint69_linear_1908_844)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.736 0l.049.027-.045.135-.044.155-.045.311v.492l.023.156.022.18.045.313.09.313.044.133.067.158.045.112-.027.01.028-.008.045.137.023.159.046.16v.159l.022.157v.361l.023.182v.448l.022.158v.201l.022.086.022.066-.054.02-.112-.269-.136-.272L8.8 3.95l-.136-.272-.112-.315-.113-.294-.114-.318-.067-.293-.068-.318-.045-.317v-.32l.022-.317.069-.319.114-.298.16-.296L8.736 0zm.376 4.52v-.108l-.023-.157v-.451l-.022-.182v-.358l-.023-.158V2.95L9 2.793l-.021-.156-.044-.131-.045-.112-.068-.16-.046-.136-.09-.319-.046-.316-.022-.18-.023-.16V.625l.046-.32.043-.152-.127.153-.155.288-.111.29-.067.31-.022.313v.312l.044.312.068.314.067.291.112.314.112.293.113.314.135.27.112.292.136.271.012.03z",
    fill: "#231F20"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M4.974 7.946l.248-.135.248-.157.247-.158.226-.135.225-.135.225-.135.203-.136.225-.135.203-.135.225-.135.203-.158.225-.112.202-.135.226-.113.247-.135.226-.135-.203.202-.203.226-.225.202-.203.203-.225.203-.225.18-.225.18-.226.18-.225.158-.248.135-.225.113-.225.09-.225.09-.248.022-.225.023-.248-.023z",
    fill: "url(#paint70_linear_1908_844)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M6.934 2.698l.18.113.157.112.18.113.158.135.158.113.135.135.158.135.135.135.135.135.135.158.135.135.113.158.135.135.113.158.112.157.113.158-.045-.158-.068-.18-.067-.18-.068-.18-.09-.18-.09-.18-.09-.158-.135-.18-.113-.158-.18-.135-.158-.135-.18-.113-.225-.09-.203-.068-.27-.067-.27-.023z",
    fill: "url(#paint71_linear_1908_844)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.936 2.67l.273.023.274.069.204.068.228.09.184.116.159.136.183.137.115.161.137.183.09.159.182.363.203.543.045.157-.05.025-.337-.471-.135-.135-.113-.158-.135-.135-.134-.157-.269-.268-.158-.136-.134-.134-.157-.113-.156-.133-.18-.113-.157-.112-.18-.112.016-.024.002-.029zm.113.067l.081.051.157.112.182.113.158.136.158.113.137.136.158.136.272.272.134.157.136.136.113.158.135.135.242.34-.2-.535-.18-.359-.088-.155-.135-.18-.11-.153-.178-.134-.156-.134-.176-.11-.222-.089-.2-.067-.268-.067-.15-.012z",
    fill: "#231F20"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87 1.122l.068.27.022.27.068.248.045.248.023.247.022.226.045.247.023.226.045.247.022.226.023.225.045.247.045.226.045.247.045.226.045.247.045-.292.023-.27.045-.293.022-.293v-.27l.023-.27-.023-.271v-.27l-.045-.27-.022-.226-.068-.248-.09-.202-.09-.203-.135-.18-.135-.158-.18-.157z",
    fill: "url(#paint72_linear_1908_844)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 1.1l.181.16.138.16.137.183.182.41.069.253.023.226.045.272v.271l.023.272-.023.271v.272l-.023.294-.045.292-.022.272L9.529 5l-.056.001-.045-.247-.045-.226-.045-.247-.045-.226-.046-.25-.044-.45-.046-.248-.022-.224-.045-.249-.023-.225-.022-.247L9 1.917l-.068-.25-.022-.27-.067-.268.028-.007.018-.021zm.03.104l.046.184.023.27.067.247.046.25.022.248.023.224.045.249.022.224.045.249.045.45.045.246.045.225.045.248.045.225.015.08.019-.123.022-.271.045-.292.023-.29v-.272l.022-.268-.022-.27v-.268l-.045-.27-.023-.223-.066-.243-.178-.4-.132-.178L9.03 1.3l-.11-.096z",
    fill: "#231F20"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.474.694L7.25.919l-.158.248-.067.27v.27l.045.27.112.293.135.293.18.293.18.27.226.27.225.27.225.226.203.248.18.18.158.203.135.135-.022-.406-.068-.337-.068-.293-.09-.248-.112-.225-.135-.203-.135-.18-.136-.18-.135-.158-.135-.18-.135-.18-.113-.203-.09-.248-.09-.247-.067-.316-.023-.36z",
    fill: "url(#paint73_linear_1908_844)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.454.674l.02.02.029-.002.022.358.067.312.179.491.11.2.269.357.135.158.272.362.137.206.114.228.09.251.068.294.068.34.027.482-.19-.19-.157-.202-.181-.181-.202-.247-.226-.226-.452-.543-.18-.271-.183-.296-.135-.294-.114-.296-.046-.275v-.276l.07-.279.161-.254.228-.227zM7.45.759L7.27.937l-.153.241-.066.263v.264l.045.265.11.29.135.29.179.29.179.27.448.537.227.227.201.246.182.182.157.202.08.08-.018-.328-.067-.335-.067-.291-.089-.245-.11-.222-.135-.2-.269-.36-.136-.158-.272-.363-.114-.205-.182-.501-.068-.318-.018-.3z",
    fill: "#231F20"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.163 4.883v-.518l.023-.27v-.27l.022-.248.023-.248.022-.248.023-.225.045-.248.045-.247.067-.248.046-.225.067-.226.09-.247.09-.226.09-.247-.383.36-.315.36L8.915 2l-.157.316-.113.292-.045.27-.022.293.022.248.068.225.067.226.09.202.09.18.09.203.068.158.068.157.022.113z",
    fill: "url(#paint74_linear_1908_844)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.414 1.281l.383-.36.046.03-.09.25-.09.224-.09.246-.067.224-.045.225-.067.247-.09.493-.022.224-.068.742v.271l-.022.27v.516h-.029l-.028.006-.022-.11-.133-.312-.09-.202-.09-.181-.092-.206-.136-.453-.023-.253.023-.298.046-.273.114-.298.159-.317.204-.34.319-.365zm-.28 3.403v-.321l.023-.27v-.271l.068-.743.023-.228.09-.498.068-.247.045-.227.068-.226.09-.249.09-.225.05-.134-.295.277-.312.357-.201.335-.157.313-.11.289-.045.266-.023.29.023.242.133.446.09.2.09.18.09.204.103.24z",
    fill: "#231F20"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M5.312 5.807l.203.022.225.045.203.023.202.045h.226l.202.022h.406l.202-.022h.203l.203-.023.202-.022h.226l.18-.023.225-.045.18-.022-.157.09-.18.067-.18.068-.18.067-.204.068-.202.045-.203.068-.203.022h-.653l-.225-.045-.225-.067-.226-.09-.225-.136-.225-.157z",
    fill: "url(#paint75_linear_1908_844)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.295 5.83l.02-.052.205.023.224.045.205.022.2.045h.225l.2.022h.403l.204-.022h.201l.407-.045h.224l.177-.022.226-.046.18-.022.018.053-.16.091-.543.204-.206.069-.2.044-.205.068-.209.024h-.656l-.23-.047-.228-.068-.227-.091-.23-.138-.225-.157zm.125.017l.133.093.222.133.222.09.223.066.22.044h.65l.198-.022.202-.067.202-.045.2-.067.538-.202.032-.018-.038.005-.226.045-.184.023h-.223l-.407.045h-.201l-.205.023H6.57l-.201-.023h-.227l-.204-.045-.204-.023-.224-.045-.09-.01z",
    fill: "#231F20"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M6.528 6.865l-.157.023-.136.022-.157.045L5.92 7l-.158.068-.157.045-.135.068-.158.067-.158.09-.135.09-.135.09-.135.09-.113.113-.112.09-.09.113-.113.112.113-.315.135-.27.157-.225L4.952 7l.225-.18.27-.18.293-.135.293-.135.315-.09.315-.113.338-.09.315-.068.338-.067.316-.068.292-.045.27-.067-.134.045-.203.112-.225.158-.293.158-.293.202-.293.158-.293.158-.27.112z",
    fill: "url(#paint76_linear_1908_844)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41 5.833l.132-.044-.016-.055-.27.067-.29.045-.317.068-.338.067-.316.068-.339.09-.317.113-.316.09-.59.273-.272.181-.227.182-.23.23-.16.228-.136.272-.114.319.047.03.113-.113.09-.112.11-.089.113-.112.133-.089.27-.18.155-.088.156-.067.134-.067.155-.045.16-.068.312-.089.133-.022.157-.022-.004-.029.011.027.27-.113.589-.317.294-.203.291-.157.227-.158.2-.111zM6.52 6.837l.266-.11.583-.314.294-.204.292-.156.226-.159.059-.032-.265.04-.315.068-.337.067-.315.068-.336.09-.316.112-.313.09-.582.268-.267.178-.223.179-.222.222-.155.221-.134.267-.07.194.022-.021.091-.114.114-.091.114-.114.41-.273.16-.091.157-.067.136-.069.159-.045.16-.068.318-.091.136-.023.154-.022z",
    fill: "#231F20"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M5.943 9.208l-.136-.293-.022-.293.022-.293.113-.27.158-.248.202-.247.248-.226.293-.202.27-.226.316-.18.315-.18.293-.158.27-.157.27-.113.225-.135.158-.09-.18.383-.18.315-.203.248-.18.225-.18.158-.203.157-.203.113-.202.135-.18.113-.203.135-.203.135-.18.158-.18.18-.18.248-.18.27-.158.338z",
    fill: "url(#paint77_linear_1908_844)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.003 5.827l-.22.467-.182.317-.204.25-.181.227-.184.16-.204.16-.204.112-.202.135-.18.113-.404.269-.178.155-.177.178-.179.246-.179.268-.156.336-.026-.013-.026.012-.138-.297-.023-.3.023-.3.116-.276.16-.253.205-.25.252-.229.292-.201.271-.226.633-.362.293-.158.273-.16.268-.11.224-.135.237-.135zM5.943 9.14l.132-.284.182-.274.182-.249.183-.183.183-.16.406-.27.18-.113.204-.136.201-.112.2-.156.178-.155.179-.223.201-.246.179-.313.14-.3-.078.045-.227.136-.27.113-.27.157-.292.158-.628.359-.27.225-.292.202-.245.222-.2.245-.155.244-.11.264-.022.286.022.285.107.232z",
    fill: "#231F20"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23 5.987l-.134.225-.158.225-.135.203-.135.225-.113.203-.112.225-.113.203-.113.225-.112.225-.09.225-.09.203-.068.225-.068.225-.067.226-.068.247-.045.248-.135-.495-.068-.45v-.384l.046-.338.067-.292.113-.27.157-.226.158-.18.18-.158.18-.157.203-.113.18-.113.158-.09.158-.09.135-.112.09-.09z",
    fill: "url(#paint78_linear_1908_844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_844",
    x1: 37.853,
    y1: 11.371,
    x2: 37.936,
    y2: 16.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1908_844",
    x1: 39.624,
    y1: 13.126,
    x2: 39.685,
    y2: 17.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1908_844",
    x1: 41.28,
    y1: 11.789,
    x2: 41.37,
    y2: 16.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1908_844",
    x1: 42.795,
    y1: 13.004,
    x2: 42.9,
    y2: 17.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1908_844",
    x1: 44.657,
    y1: 12.045,
    x2: 44.729,
    y2: 16.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1908_844",
    x1: 45.968,
    y1: 12.882,
    x2: 46.017,
    y2: 17.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1908_844",
    x1: 47.614,
    y1: 12.309,
    x2: 47.657,
    y2: 15.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1908_844",
    x1: 49.262,
    y1: 12.755,
    x2: 49.309,
    y2: 16.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1908_844",
    x1: 50.74,
    y1: 12.076,
    x2: 50.752,
    y2: 14.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1908_844",
    x1: 52.478,
    y1: 10.931,
    x2: 52.3,
    y2: 15.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1908_844",
    x1: 53.313,
    y1: 12.019,
    x2: 53.324,
    y2: 13.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1908_844",
    x1: 55.073,
    y1: 11.318,
    x2: 54.945,
    y2: 15.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1908_844",
    x1: 55.583,
    y1: 11.969,
    x2: 55.593,
    y2: 13.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1908_844",
    x1: 56.203,
    y1: 11.955,
    x2: 56.212,
    y2: 13.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1908_844",
    x1: 56.891,
    y1: 13.282,
    x2: 56.894,
    y2: 14.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1908_844",
    x1: 56.905,
    y1: 11.94,
    x2: 56.911,
    y2: 13.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1908_844",
    x1: 38.223,
    y1: 12.741,
    x2: 38.714,
    y2: 6.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1908_844",
    x1: 40.899,
    y1: 9.887,
    x2: 42.302,
    y2: 4.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1908_844",
    x1: 41.191,
    y1: 13.639,
    x2: 42.073,
    y2: 7.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1908_844",
    x1: 43.454,
    y1: 11.631,
    x2: 44.678,
    y2: 6.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1908_844",
    x1: 44.494,
    y1: 14.639,
    x2: 44.87,
    y2: 8.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1908_844",
    x1: 46.072,
    y1: 13.416,
    x2: 46.698,
    y2: 8.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1908_844",
    x1: 48.008,
    y1: 15.702,
    x2: 48.338,
    y2: 9.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1908_844",
    x1: 52.048,
    y1: 12.047,
    x2: 52.055,
    y2: 14.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1908_844",
    x1: 51.077,
    y1: 10.721,
    x2: 50.975,
    y2: 15.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1908_844",
    x1: 53.539,
    y1: 11.089,
    x2: 53.428,
    y2: 15.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1908_844",
    x1: 55.941,
    y1: 11.448,
    x2: 55.871,
    y2: 15.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1908_844",
    x1: 56.262,
    y1: 11.954,
    x2: 56.267,
    y2: 13.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1908_844",
    x1: 54.66,
    y1: 11.989,
    x2: 54.666,
    y2: 13.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#F7DB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#F3C87B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2C179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1908_844",
    x1: 10.426,
    y1: 6.565,
    x2: 7.759,
    y2: 7.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1908_844",
    x1: 11.521,
    y1: 6.937,
    x2: 8.881,
    y2: 7.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1908_844",
    x1: 12.812,
    y1: 7.374,
    x2: 10.002,
    y2: 8.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1908_844",
    x1: 14.225,
    y1: 7.852,
    x2: 11.28,
    y2: 9.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1908_844",
    x1: 15.202,
    y1: 7.298,
    x2: 12.035,
    y2: 9.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#873A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#9E3B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#C23B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC3E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1908_844",
    x1: 16.149,
    y1: 9.735,
    x2: 14.475,
    y2: 12.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1908_844",
    x1: 17.577,
    y1: 9.943,
    x2: 16.368,
    y2: 12.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1908_844",
    x1: 18.879,
    y1: 9.78,
    x2: 16.944,
    y2: 16.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1908_844",
    x1: 20.761,
    y1: 10.407,
    x2: 19.533,
    y2: 13.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1908_844",
    x1: 22.227,
    y1: 10.127,
    x2: 20.529,
    y2: 17.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1908_844",
    x1: 23.554,
    y1: 10.182,
    x2: 23.05,
    y2: 13.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1908_844",
    x1: 24.972,
    y1: 10.906,
    x2: 24.465,
    y2: 15.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1908_844",
    x1: 26.314,
    y1: 10.991,
    x2: 25.805,
    y2: 15.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1908_844",
    x1: 27.688,
    y1: 10.693,
    x2: 26.779,
    y2: 17.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1908_844",
    x1: 29.454,
    y1: 10.876,
    x2: 28.792,
    y2: 18.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1908_844",
    x1: 30.663,
    y1: 11.848,
    x2: 30.252,
    y2: 15.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1908_844",
    x1: 32.278,
    y1: 11.169,
    x2: 31.835,
    y2: 18.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1908_844",
    x1: 33.542,
    y1: 12.267,
    x2: 33.254,
    y2: 15.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1908_844",
    x1: 35.22,
    y1: 11.474,
    x2: 34.816,
    y2: 18.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1908_844",
    x1: 36.65,
    y1: 12.719,
    x2: 36.425,
    y2: 16.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#9C2F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B92770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#D02162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#DF1E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#E91F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1908_844",
    x1: 10.636,
    y1: 4.392,
    x2: 14.688,
    y2: 1.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1908_844",
    x1: 11.555,
    y1: 4.772,
    x2: 15.481,
    y2: 0.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1908_844",
    x1: 12.791,
    y1: 5.044,
    x2: 15.717,
    y2: -0.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1908_844",
    x1: 13.983,
    y1: 5.668,
    x2: 16.751,
    y2: 0.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1908_844",
    x1: 15.623,
    y1: 5.901,
    x2: 17.873,
    y2: 0.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1908_844",
    x1: 16.736,
    y1: 6.685,
    x2: 18.868,
    y2: 0.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1908_844",
    x1: 18.466,
    y1: 6.762,
    x2: 20.288,
    y2: 0.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1908_844",
    x1: 20.271,
    y1: 7.308,
    x2: 22.206,
    y2: 1.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1908_844",
    x1: 21.399,
    y1: 8.405,
    x2: 23.273,
    y2: 2.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1908_844",
    x1: 23.025,
    y1: 8.141,
    x2: 24.583,
    y2: 2.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1908_844",
    x1: 23.935,
    y1: 9.34,
    x2: 25.571,
    y2: 3.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1908_844",
    x1: 25.595,
    y1: 8.919,
    x2: 27.149,
    y2: 2.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1908_844",
    x1: 26.27,
    y1: 10.202,
    x2: 27.683,
    y2: 4.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1908_844",
    x1: 28.358,
    y1: 9.755,
    x2: 29.28,
    y2: 3.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1908_844",
    x1: 28.925,
    y1: 11.182,
    x2: 30.11,
    y2: 5.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1908_844",
    x1: 31.037,
    y1: 10.566,
    x2: 31.808,
    y2: 4.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1908_844",
    x1: 32.2,
    y1: 10.918,
    x2: 32.917,
    y2: 4.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1908_844",
    x1: 33.64,
    y1: 11.354,
    x2: 34.281,
    y2: 5.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1908_844",
    x1: 34.507,
    y1: 10.474,
    x2: 36.083,
    y2: 4.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1908_844",
    x1: 35.52,
    y1: 11.375,
    x2: 36.971,
    y2: 5.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#8A2F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#B4256C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#D31C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#EC1E4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1908_844",
    x1: 9.589,
    y1: 0.048,
    x2: 5.374,
    y2: 0.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1908_844",
    x1: 8.966,
    y1: -0.147,
    x2: 7.84,
    y2: 9.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1908_844",
    x1: 9.265,
    y1: -0.054,
    x2: 6.488,
    y2: 9.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1908_844",
    x1: 10.089,
    y1: 0.203,
    x2: 5.98,
    y2: 0.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1908_844",
    x1: 9.012,
    y1: -0.133,
    x2: 2.649,
    y2: 5.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1908_844",
    x1: 10.016,
    y1: 0.181,
    x2: 4.647,
    y2: 1.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1908_844",
    x1: 8.834,
    y1: -0.188,
    x2: 8.767,
    y2: 9.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1908_844",
    x1: 8.666,
    y1: -0.241,
    x2: 7.792,
    y2: 9.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1908_844",
    x1: 9.589,
    y1: 0.048,
    x2: 6.384,
    y2: 9.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1908_844",
    x1: 10.404,
    y1: 0.302,
    x2: 4.055,
    y2: 5.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CDDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B4CBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#90ABBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#5F8096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#486D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#5D7E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#88A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AAC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#C1D5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#D0E1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E5EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApache);
export default __webpack_public_path__ + "static/media/apache.34b13df0f6ff94ce59bb0bb2760909d7.svg";
export { ForwardRef as ReactComponent };